var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountantAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-589"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-589",
    points: "224.62 497.54 48.07 395.6 309.99 244.51 486.54 346.45 224.62 497.54",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-589"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 288.36 251.26 248.16 199.05 218.02 199.05 258.21 251.26 288.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 248.16 323.49 206.52 323.49 246.71 251.26 288.36 251.26 248.16",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 248.16 197.51 217.11 271.28 174.57 325.04 205.62 251.26 248.16",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.26 248.16 251.26 258.21 197.51 227.18 197.51 217.11 251.26 248.16",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.04 205.62 251.26 248.16 251.26 258.21 325.04 215.68 325.04 205.62",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,228.07v2.21l52.21,30.14v-2.21Zm124.44-11.5-72.23,41.64v2.21l72.23-41.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,254.27,216.24,244c-.77-.45-1.39-.09-1.39.8v10.54a3.06,3.06,0,0,0,1.39,2.41L234.08,268c.76.44,1.39.09,1.39-.8V256.68A3.12,3.12,0,0,0,234.08,254.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,254.27,216.24,244c-.77-.45-1.39-.09-1.39.8v10.54a3.06,3.06,0,0,0,1.39,2.41L234.08,268c.76.44,1.39.09,1.39-.8V256.68A3.12,3.12,0,0,0,234.08,254.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,255.47l-15.55-9c-.51-.29-.92-.05-.92.54v7.9a2.06,2.06,0,0,0,.92,1.61l15.55,9c.52.29.93.05.93-.54v-7.9A2,2,0,0,0,232.93,255.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,257.56a.23.23,0,0,0,.2-.12.23.23,0,0,0-.09-.31l-14.68-8.47a.23.23,0,0,0-.31.08.24.24,0,0,0,.08.31l14.69,8.48A.2.2,0,0,0,232.5,257.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,259.5a.23.23,0,0,0,.2-.12.22.22,0,0,0-.09-.3l-14.68-8.48a.23.23,0,0,0-.31.08.24.24,0,0,0,.08.31l14.69,8.48A.2.2,0,0,0,232.5,259.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,261.44a.24.24,0,0,0,.2-.11.23.23,0,0,0-.09-.31l-14.68-8.48a.23.23,0,0,0-.31.08.24.24,0,0,0,.08.31l14.69,8.48A.2.2,0,0,0,232.5,261.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,263.38a.24.24,0,0,0,.2-.11.23.23,0,0,0-.09-.31l-14.68-8.48a.23.23,0,0,0-.23.39l14.69,8.48A.2.2,0,0,0,232.5,263.38Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-589"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.75 203.14 248.26 244.95 198.79 216.37 271.28 174.57 320.75 203.14",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-589"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.82 241.78 247.82 201.58 195.61 171.44 195.61 211.63 247.82 241.78",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.82 201.58 320.04 159.94 320.04 200.13 247.82 241.78 247.82 201.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.82 201.58 194.06 170.53 267.83 127.99 321.59 159.04 247.82 201.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.82 201.58 247.82 211.63 194.06 180.59 194.06 170.53 247.82 201.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.59 159.04 247.82 201.58 247.82 211.63 321.59 169.09 321.59 159.04",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,181.49v2.21l52.21,30.14v-2.21ZM320,170l-72.22,41.64v2.21L320,172.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,207.69l-17.84-10.3c-.76-.44-1.39-.08-1.39.81v10.54a3.09,3.09,0,0,0,1.39,2.41l17.84,10.3c.77.44,1.39.08,1.39-.8V210.1A3.06,3.06,0,0,0,230.63,207.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,207.69l-17.84-10.3c-.76-.44-1.39-.08-1.39.81v10.54a3.09,3.09,0,0,0,1.39,2.41l17.84,10.3c.77.44,1.39.08,1.39-.8V210.1A3.06,3.06,0,0,0,230.63,207.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,208.89l-15.55-9c-.52-.3-.93-.06-.93.53v7.91a2,2,0,0,0,.93,1.61l15.55,9c.51.3.92.06.92-.53v-7.91A2,2,0,0,0,229.49,208.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05,211a.23.23,0,0,0,.2-.11.24.24,0,0,0-.08-.31l-14.69-8.47a.22.22,0,0,0-.31.08.23.23,0,0,0,.09.31l14.68,8.47A.2.2,0,0,0,229.05,211Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05,212.92a.22.22,0,0,0,.2-.12.24.24,0,0,0-.08-.31L214.48,204a.22.22,0,0,0-.31.08.23.23,0,0,0,.09.31l14.68,8.48A.2.2,0,0,0,229.05,212.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05,214.86a.22.22,0,0,0,.2-.12.23.23,0,0,0-.08-.3L214.48,206a.22.22,0,1,0-.22.39l14.68,8.48A.2.2,0,0,0,229.05,214.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.05,216.8a.23.23,0,0,0,.2-.11.24.24,0,0,0-.08-.31l-14.69-8.48a.22.22,0,1,0-.22.39l14.68,8.48A.2.2,0,0,0,229.05,216.8Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.66,166.15l49.06,28a1,1,0,0,0,.56.15,1.07,1.07,0,0,0,.57-.13l60.88-35.14a.38.38,0,0,0,0-.69l-49.1-28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,158.27a1.16,1.16,0,0,1-.55.84L251.72,191.9a1.06,1.06,0,0,1-1,0l-44.35-25.32.06-1.08,57.86-33.41,44.37,25.34A1.07,1.07,0,0,1,309.1,158.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,190.94,251.2,192a1.11,1.11,0,0,0,.52-.12l56.83-32.79a1.2,1.2,0,0,0,.56-.84,1.1,1.1,0,0,0-.47-.86c.27.17.25.45,0,.62l-56.82,32.8A.91.91,0,0,1,251.26,190.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,165.48l44.34,25.33a.88.88,0,0,0,.51.13.91.91,0,0,0,.52-.11L308.6,158c.29-.17.31-.45,0-.62l-44.38-25.34Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,165.48l-.06,1.08,44.35,25.32a1,1,0,0,0,.5.14l.06-1.08a.88.88,0,0,1-.51-.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.08 165.92 264.96 132.53 265.68 118.36 207.79 151.92 207.08 165.92",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.08 165.92 264.96 132.53 265.68 118.36 207.79 151.92 207.08 165.92",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.86,150.64a1.42,1.42,0,0,1,.57,1.17l-.14,2.87a1.54,1.54,0,0,1-.69,1.15L252,188.48a1.34,1.34,0,0,1-1.26,0l-37.53-22.91.23-4.42,57.86-33.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,127.72l37.54,22.92a.41.41,0,0,1,0,.77l-56.57,32.65a1.36,1.36,0,0,1-1.27,0l-37.52-22.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.37,161.57a1.63,1.63,0,0,1-.44.15,1.24,1.24,0,0,1-.69,0,.43.43,0,0,1-.21-.09c-.34-.2-.28-.57.14-.81a1.43,1.43,0,0,1,.61-.17,1.12,1.12,0,0,1,.72.14.09.09,0,0,1,.06.06C218.82,161,218.75,161.35,218.37,161.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,184.19l-.22,4.43a1.38,1.38,0,0,0,.65-.14l56.57-32.64a1.58,1.58,0,0,0,.69-1.15l.14-2.88a1.48,1.48,0,0,0-.43-1.05c.18.21.13.47-.17.65l-56.58,32.64A1.08,1.08,0,0,1,251.6,184.19Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.91,155.32a2.37,2.37,0,0,1,2.61.21c1.53,1,2.78,3.26,3.29,5.69l-.87.12a8.3,8.3,0,0,0-2.89-5,2.12,2.12,0,0,0-1.07-.38,1.3,1.3,0,0,0-.67.18c-.71.43-1.16,1.59-1.2,3.12-.06,2.94,1.35,6.28,3.15,7.46a2,2,0,0,0,1.29.36l.91.59-.06,0a2,2,0,0,1-1.11.3,2.9,2.9,0,0,1-1.5-.51c-2.06-1.34-3.61-5-3.54-8.23C210.3,157.35,210.9,155.92,211.91,155.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.91,155.32a2.37,2.37,0,0,1,2.61.21c1.53,1,2.78,3.26,3.29,5.69l-.87.12a8.3,8.3,0,0,0-2.89-5,2.12,2.12,0,0,0-1.07-.38,1.3,1.3,0,0,0-.67.18c-.71.43-1.16,1.59-1.2,3.12-.06,2.94,1.35,6.28,3.15,7.46a2,2,0,0,0,1.29.36l.91.59-.06,0a2,2,0,0,1-1.11.3,2.9,2.9,0,0,1-1.5-.51c-2.06-1.34-3.61-5-3.54-8.23C210.3,157.35,210.9,155.92,211.91,155.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,149.27a1.17,1.17,0,0,1-.55.85l-56.84,32.79a1.06,1.06,0,0,1-1,0l-44.09-30.43.05-1.08L265,118l44.11,30.43A1.09,1.09,0,0,1,309.56,149.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.72,182l-.06,1.07a1.1,1.1,0,0,0,.52-.11L309,150.12a1.2,1.2,0,0,0,.55-.85,1.1,1.1,0,0,0-.47-.86.33.33,0,0,1,0,.62l-56.83,32.81A1,1,0,0,1,251.72,182Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,151.38l44.09,30.44a1,1,0,0,0,.51.13,1,1,0,0,0,.51-.11L309.06,149a.33.33,0,0,0,0-.62L265,118Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,151.38l-.05,1.08,44.09,30.43a1,1,0,0,0,.5.13l.06-1.07a1,1,0,0,1-.51-.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.41 165.48 207.12 151.41 207.79 151.92 207.08 165.92 206.41 165.48",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.41 165.48 207.12 151.41 207.79 151.92 207.08 165.92 206.41 165.48",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.78,151.2a.81.81,0,0,1-.44-.72c0-.26,0-1.1,0-1.1l55.92-31.63a2.46,2.46,0,0,1,2.33,0l43.56,28.39-57.88,33.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.78,151.2a.81.81,0,0,1-.44-.72c0-.26,0-1.1,0-1.1l55.92-31.63a2.46,2.46,0,0,1,2.33,0l43.56,28.39-57.88,33.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,150.13a.77.77,0,0,1,.07-1.43l55.46-32a2.47,2.47,0,0,1,2.33,0l43.56,28.39-57.89,33.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,150.13a.77.77,0,0,1,.07-1.43l55.46-32a2.47,2.47,0,0,1,2.33,0l43.56,28.39-57.89,33.4Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,137.72l-32.25-21a2.45,2.45,0,0,0-2.32,0L214.2,146.4,210,143.64l-.28,5.45.08,0a.75.75,0,0,0,.35,1l36.93,24.06L305,140.78l.31-5.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,144.17a.77.77,0,0,1,.08-1.43l55.46-32a2.44,2.44,0,0,1,2.33,0l36.95,24.07-57.88,33.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.4 168.23 247.09 174.18 304.98 140.78 305.28 134.83 247.4 168.23",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.13,165.91a1.27,1.27,0,0,1-.44.15,1.2,1.2,0,0,1-.68,0,.67.67,0,0,1-.21-.09c-.34-.21-.28-.58.13-.82a1.59,1.59,0,0,1,.62-.17,1.2,1.2,0,0,1,.72.14s0,0,.06.06C248.59,165.38,248.52,165.69,248.13,165.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,164.71a3,3,0,0,0-1.6-.55,2.12,2.12,0,0,0-1.71.8A2.56,2.56,0,0,0,247,166a1.2,1.2,0,0,0,.68,0,1.73,1.73,0,0,1,.64-.9,1.82,1.82,0,0,1,2.16.15,6.61,6.61,0,0,1,2.61,5.35c-.1,2-1.41,2.72-2.94,1.75l-.68.39.28.19a3,3,0,0,0,1.59.54h0a2.06,2.06,0,0,0,1.71-.81,3.4,3.4,0,0,0,.7-2A7.27,7.27,0,0,0,250.86,164.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,164.71a3,3,0,0,0-1.6-.55,2.12,2.12,0,0,0-1.71.8A2.56,2.56,0,0,0,247,166a1.2,1.2,0,0,0,.68,0,1.73,1.73,0,0,1,.64-.9,1.82,1.82,0,0,1,2.16.15,6.61,6.61,0,0,1,2.61,5.35c-.1,2-1.41,2.72-2.94,1.75l-.68.39.28.19a3,3,0,0,0,1.59.54h0a2.06,2.06,0,0,0,1.71-.81,3.4,3.4,0,0,0,.7-2A7.27,7.27,0,0,0,250.86,164.71Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,165l-43.57-24,0,.78a1.34,1.34,0,0,0,.53,1.08l43,23.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,165l-43.57-24,0,.78a1.34,1.34,0,0,0,.53,1.08l43,23.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.27,141.7a.77.77,0,0,1,.07-1.43l55.46-32a2.47,2.47,0,0,1,2.33,0L310.92,132,253,165.43Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.32 179.58 310.2 146.19 310.92 132.02 253.04 165.44 252.32 179.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.32 179.58 310.2 146.19 310.92 132.02 253.04 165.44 252.32 179.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,170.68a2,2,0,0,1-1.63-.87,3.36,3.36,0,0,1-.49-2.07,7.87,7.87,0,0,1,3.52-5.87,3.22,3.22,0,0,1,1.65-.48c1.36,0,2.21,1.21,2.12,2.94a7.85,7.85,0,0,1-3.52,5.86,3.21,3.21,0,0,1-1.65.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,167.75c-.1,1.95,1.15,2.77,2.79,1.82a7.13,7.13,0,0,0,3.16-5.25c.1-2-1.15-2.77-2.79-1.82A7.16,7.16,0,0,0,261.57,167.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.39,160.83l-.05,1.07c-.11,2.14,1.26,3,3.07,2L303,148a7.88,7.88,0,0,0,3.46-5.77l.05-1.07c.11-2.15-1.26-3-3.06-2l-27.56,15.91A7.83,7.83,0,0,0,272.39,160.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.65 179.15 252.36 165.07 253.04 165.44 252.32 179.58 251.65 179.15",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.65 179.15 252.36 165.07 253.04 165.44 252.32 179.58 251.65 179.15",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.16,163.51a1.36,1.36,0,0,1-.61-1.24V79.63a3.45,3.45,0,0,1,1.58-2.73l97.42-56.24a1.37,1.37,0,0,1,1.37-.1,1.35,1.35,0,0,1,.61,1.24v82.64a3.45,3.45,0,0,1-1.58,2.73L18.53,163.41a1.67,1.67,0,0,1-.82.24A1.12,1.12,0,0,1,17.16,163.51ZM116,21.35,18.53,77.59a2.64,2.64,0,0,0-1.18,2v82.64a.66.66,0,0,0,.2.55.63.63,0,0,0,.58-.1l97.42-56.24a2.64,2.64,0,0,0,1.18-2V21.8a.63.63,0,0,0-.21-.55.34.34,0,0,0-.16,0A.87.87,0,0,0,116,21.35Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16,163.51a1.36,1.36,0,0,1-.61-1.24V79.63a3.45,3.45,0,0,1,1.58-2.73l97.42-56.24a1.37,1.37,0,0,1,1.37-.1,1.35,1.35,0,0,1,.61,1.24v82.64a3.45,3.45,0,0,1-1.58,2.73L18.53,163.41a1.67,1.67,0,0,1-.82.24A1.12,1.12,0,0,1,17.16,163.51ZM116,21.35,18.53,77.59a2.64,2.64,0,0,0-1.18,2v82.64a.66.66,0,0,0,.2.55.63.63,0,0,0,.58-.1l97.42-56.24a2.64,2.64,0,0,0,1.18-2V21.8a.63.63,0,0,0-.21-.55.34.34,0,0,0-.16,0A.87.87,0,0,0,116,21.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,139.42l-.13,0a.61.61,0,0,1-.46-.73l.69-3.18c2.82-13,6.68-30.73,12.13-33.88,2.93-1.69,4.68,1.08,6.22,3.51,2,3.17,3.41,5,6.11,3.42,2.91-1.68,4.64-9.55,6.47-17.89C60.36,80.25,63,68.45,68.75,65.1a3.55,3.55,0,0,1,3.33-.32c3.65,1.6,5.48,9.91,7.43,18.71,1.69,7.64,3.43,15.54,6.14,16.74a1.89,1.89,0,0,0,1.77-.21c2.82-1.63,4.13-6.84,5.39-11.88,1.43-5.68,2.9-11.56,6.66-13.73a2.32,2.32,0,0,1,2.19-.15c2.87,1.31,4.51,8.71,5.83,15.55l.15.77a.62.62,0,0,1-.49.72.61.61,0,0,1-.71-.48l-.15-.78c-.84-4.39-2.6-13.51-5.13-14.67a1.09,1.09,0,0,0-1.08.1c-3.31,1.91-4.72,7.53-6.08,13s-2.7,10.75-6,12.64a3.08,3.08,0,0,1-2.88.26c-3.27-1.44-5-9.28-6.83-17.58C76.61,76,74.67,67.25,71.59,65.9a2.33,2.33,0,0,0-2.22.26C64,69.24,61.5,80.76,59.26,90.91c-2,9-3.68,16.74-7,18.68-3.92,2.26-6.05-1.11-7.76-3.81-1.8-2.86-2.84-4.1-4.57-3.11-5,2.88-8.93,21-11.54,33.08l-.7,3.19A.61.61,0,0,1,27,139.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33,99.92a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.82,2,1.18a4.49,4.49,0,0,0,2-3.53C42.37,99.8,41.46,99.27,40.33,99.92Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.33,99.92a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.82,2,1.18a4.49,4.49,0,0,0,2-3.53C42.37,99.8,41.46,99.27,40.33,99.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.08,63.44A4.49,4.49,0,0,0,67,67c0,1.3.91,1.82,2,1.17a4.51,4.51,0,0,0,2-3.52C71.11,63.32,70.2,62.79,69.08,63.44Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.08,63.44A4.49,4.49,0,0,0,67,67c0,1.3.91,1.82,2,1.17a4.51,4.51,0,0,0,2-3.52C71.11,63.32,70.2,62.79,69.08,63.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.91,72.85a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.83,2,1.18A4.49,4.49,0,0,0,102,74C102,72.73,101,72.21,99.91,72.85Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.91,72.85a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.83,2,1.18A4.49,4.49,0,0,0,102,74C102,72.73,101,72.21,99.91,72.85Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.32,40.11a14.12,14.12,0,0,0-3.75.84c-2.77.91-4,1.32-4-.18a2.31,2.31,0,0,1,.19-.9,4.81,4.81,0,0,1,2.14-2.14c1.82-1.06,2.84-.81,3.09.36l5-4.25A2.92,2.92,0,0,0,152,31.62a7.72,7.72,0,0,0-3.11.73v-3l-2.57,1.5-1.54.89v3c-3.49,2.54-5.67,5.86-5.67,9.45a5.19,5.19,0,0,0,.31,2c.77,1.93,2.88,1.67,5.11,1,.78-.23,1.54-.51,2.21-.73,1.59-.52,2.74-.72,2.74.64a3.86,3.86,0,0,1-2.26,3.07c-2.15,1.25-3,.23-3.17-.76l-5.23,4.43a4.7,4.7,0,0,0,.39,1.1,3,3,0,0,0,3.33,1.44,9.7,9.7,0,0,0,2.57-.77v3l4.07-2.35V53.2c3.53-2.6,6-6.1,6-9.77C155.19,40.8,153.94,40.07,152.32,40.11Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,40.11a14.12,14.12,0,0,0-3.75.84c-2.77.91-4,1.32-4-.18a2.31,2.31,0,0,1,.19-.9,4.81,4.81,0,0,1,2.14-2.14c1.82-1.06,2.84-.81,3.09.36l5-4.25A2.92,2.92,0,0,0,152,31.62a7.72,7.72,0,0,0-3.11.73v-3l-2.57,1.5-1.54.89v3c-3.49,2.54-5.67,5.86-5.67,9.45a5.19,5.19,0,0,0,.31,2c.77,1.93,2.88,1.67,5.11,1,.78-.23,1.54-.51,2.21-.73,1.59-.52,2.74-.72,2.74.64a3.86,3.86,0,0,1-2.26,3.07c-2.15,1.25-3,.23-3.17-.76l-5.23,4.43a4.7,4.7,0,0,0,.39,1.1,3,3,0,0,0,3.33,1.44,9.7,9.7,0,0,0,2.57-.77v3l4.07-2.35V53.2c3.53-2.6,6-6.1,6-9.77C155.19,40.8,153.94,40.07,152.32,40.11Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,15.36a1.52,1.52,0,0,0-1.53.1l-24.26,14A4.47,4.47,0,0,0,133,31.28a6.08,6.08,0,0,0-.44,1.06h0a4.66,4.66,0,0,0-.22,1.38V46.91l-5.75,7.2a1,1,0,0,0,.69,1.63l5.06.45v13.2a1.9,1.9,0,0,0,.78,1.75,1.27,1.27,0,0,0,.63.17,1.79,1.79,0,0,0,.9-.27l24.26-14a4.55,4.55,0,0,0,1.58-1.81,5.43,5.43,0,0,0,.66-2.45V17.11A1.92,1.92,0,0,0,160.37,15.36Zm0,37.42a4.6,4.6,0,0,1-.58,2.1,3.73,3.73,0,0,1-1.29,1.51l-24.26,14a.77.77,0,0,1-.77.1,1.24,1.24,0,0,1-.41-1.1V55.85a.37.37,0,0,0-.34-.37l-5.4-.48a.25.25,0,0,1-.21-.16.23.23,0,0,1,0-.26l5.84-7.3a.41.41,0,0,0,.08-.24V33.72a3.85,3.85,0,0,1,.19-1.16,5.84,5.84,0,0,1,.39-.94,3.62,3.62,0,0,1,1.29-1.5l24.25-14A.84.84,0,0,1,160,16a1.25,1.25,0,0,1,.41,1.1Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,15.36a1.52,1.52,0,0,0-1.53.1l-24.26,14A4.47,4.47,0,0,0,133,31.28a6.08,6.08,0,0,0-.44,1.06h0a4.66,4.66,0,0,0-.22,1.38V46.91l-5.75,7.2a1,1,0,0,0,.69,1.63l5.06.45v13.2a1.9,1.9,0,0,0,.78,1.75,1.27,1.27,0,0,0,.63.17,1.79,1.79,0,0,0,.9-.27l24.26-14a4.55,4.55,0,0,0,1.58-1.81,5.43,5.43,0,0,0,.66-2.45V17.11A1.92,1.92,0,0,0,160.37,15.36Zm0,37.42a4.6,4.6,0,0,1-.58,2.1,3.73,3.73,0,0,1-1.29,1.51l-24.26,14a.77.77,0,0,1-.77.1,1.24,1.24,0,0,1-.41-1.1V55.85a.37.37,0,0,0-.34-.37l-5.4-.48a.25.25,0,0,1-.21-.16.23.23,0,0,1,0-.26l5.84-7.3a.41.41,0,0,0,.08-.24V33.72a3.85,3.85,0,0,1,.19-1.16,5.84,5.84,0,0,1,.39-.94,3.62,3.62,0,0,1,1.29-1.5l24.25-14A.84.84,0,0,1,160,16a1.25,1.25,0,0,1,.41,1.1Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbols--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plus--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299,36.27l6.86-4a1.14,1.14,0,0,1,1.18.11L309.76,34v7.92l-9.55-5.51A1.1,1.1,0,0,0,299,36.27Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.92,59.43l6.86,4v3.89a1.13,1.13,0,0,1-.49,1.07h0l-6.87,4a1.15,1.15,0,0,0,.49-1.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.07,52.82v7.24a1.12,1.12,0,0,1-.49,1.07h0l-6.86,4h0a1.16,1.16,0,0,0,.49-1.09V56.78a3.28,3.28,0,0,0-.49-1.64l0,0a3.13,3.13,0,0,0-1.15-1.21l-9.62-5.56V36.51a3.28,3.28,0,0,0-.49-1.64v0a3.27,3.27,0,0,0-1.17-1.24l-7.81-4.51A1.17,1.17,0,0,0,310.3,29L317.14,25h0a1.11,1.11,0,0,1,1.15.11l7.81,4.51a3.31,3.31,0,0,1,1.17,1.25,0,0,0,0,1,0,0,3.28,3.28,0,0,1,.49,1.64V44.37l9.62,5.55a3.35,3.35,0,0,1,.63.51,4,4,0,0,1,.55.75A3.28,3.28,0,0,1,339.07,52.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,36.27l6.86-4a1.14,1.14,0,0,1,1.18.11L309.76,34v7.92l-9.55-5.51A1.1,1.1,0,0,0,299,36.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,34v7.92l-9.55-5.51a1.1,1.1,0,0,0-1.18-.11l6.86-4a1.14,1.14,0,0,1,1.18.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,41.89V30.07a1,1,0,0,1,1.68-1l7.81,4.51a3.75,3.75,0,0,1,1.67,2.91V48.34l9.62,5.55a3.71,3.71,0,0,1,1.67,2.89V64a1.13,1.13,0,0,1-.49,1.07,1.14,1.14,0,0,1-1.18-.1l-9.62-5.56V71.25a1,1,0,0,1-1.67,1l-7.81-4.51a3.8,3.8,0,0,1-1.68-2.9V53l-9.55-5.52A3.25,3.25,0,0,1,299,46.22a3.3,3.3,0,0,1-.5-1.65V37.34a1.12,1.12,0,0,1,.5-1.07,1.1,1.1,0,0,1,1.18.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,29.69a.74.74,0,0,1,.32.12l7.81,4.51a2.51,2.51,0,0,1,.88,1,2.48,2.48,0,0,1,.39,1.24V48.81l.41.23,9.61,5.56a2.55,2.55,0,0,1,.88.95,2.42,2.42,0,0,1,.38,1.23V64c0,.19,0,.33-.12.37a.69.69,0,0,1-.32-.11l-9.62-5.56L320.11,58V71.25c0,.08,0,.32-.13.38a.77.77,0,0,1-.32-.12L311.85,67a2.48,2.48,0,0,1-.88-1,2.54,2.54,0,0,1-.39-1.24V52.52l-.41-.24-9.55-5.52a2.41,2.41,0,0,1-.88-.95,2.48,2.48,0,0,1-.39-1.24V37.34c0-.14,0-.33.13-.37a.59.59,0,0,1,.32.12l9.55,5.51,1.23.71V30.07c0-.15,0-.33.09-.37h0m0-.82a.89.89,0,0,0-.45.12,1.15,1.15,0,0,0-.5,1.08V41.89l-9.55-5.51a1.41,1.41,0,0,0-.73-.23.89.89,0,0,0-.45.12,1.12,1.12,0,0,0-.5,1.07v7.23a3.3,3.3,0,0,0,.5,1.65,3.25,3.25,0,0,0,1.18,1.25L309.76,53V64.81a3.8,3.8,0,0,0,1.68,2.9l7.81,4.51a1.51,1.51,0,0,0,.73.23.89.89,0,0,0,.45-.12,1.15,1.15,0,0,0,.5-1.08V59.43L330.54,65a1.45,1.45,0,0,0,.73.22.89.89,0,0,0,.45-.12,1.13,1.13,0,0,0,.49-1.07V56.78a3.71,3.71,0,0,0-1.67-2.89l-9.61-5.55V36.52a3.8,3.8,0,0,0-1.68-2.91l-7.81-4.51a1.54,1.54,0,0,0-.73-.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.28,30.9l-6.86,4a3.27,3.27,0,0,0-1.17-1.24l-7.81-4.51A1.17,1.17,0,0,0,310.3,29L317.14,25h0a1.11,1.11,0,0,1,1.15.11l7.81,4.51A3.31,3.31,0,0,1,327.28,30.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,51.15l-6.85,4a3.13,3.13,0,0,0-1.15-1.21l-9.62-5.56,6.86-4,9.62,5.55a3.35,3.35,0,0,1,.63.51A4.57,4.57,0,0,1,338.54,51.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,29h0Z",
    style: {
      fill: "#E68072"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Minus--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.23,103.15v7.23a1.15,1.15,0,0,1-.49,1.08h0l-6.86,4h0a1.14,1.14,0,0,0,.49-1.07v-7.24a3.29,3.29,0,0,0-.49-1.65s0-.07-.07-.1a3.15,3.15,0,0,0-1.11-1.15l-9.61-5.55-11.17-6.45-9.55-5.51a1.14,1.14,0,0,0-1.18-.11l6.86-4a1.12,1.12,0,0,1,1.18.11l2.69,1.55L326,94.7l9.61,5.55a2.32,2.32,0,0,1,.45.34,3.6,3.6,0,0,1,.73.91A3.29,3.29,0,0,1,337.23,103.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,101.41l-6.84,4a3.15,3.15,0,0,0-1.11-1.15l-9.61-5.55-11.17-6.45-9.55-5.51a1.14,1.14,0,0,0-1.18-.11l6.86-4a1.12,1.12,0,0,1,1.18.11l2.69,1.55L326,94.7l9.61,5.55a2.32,2.32,0,0,1,.45.34A4.24,4.24,0,0,1,336.65,101.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,92.21l11.16,6.45,9.62,5.55a3.71,3.71,0,0,1,1.67,2.9v7.23a1,1,0,0,1-1.67,1l-9.62-5.55-11.16-6.45-9.55-5.51a3.25,3.25,0,0,1-1.18-1.25,3.36,3.36,0,0,1-.5-1.65V87.67a1,1,0,0,1,1.68-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.64,87.29a.7.7,0,0,1,.32.12l9.55,5.51,11.17,6.45,9.61,5.55a2.55,2.55,0,0,1,.88,1,2.46,2.46,0,0,1,.38,1.24v7.23c0,.19,0,.34-.12.38a.64.64,0,0,1-.32-.12l-9.62-5.55-11.16-6.45-9.55-5.51a2.55,2.55,0,0,1-.88-1,2.51,2.51,0,0,1-.39-1.24V87.67c0-.16,0-.33.09-.37h0m0-.82a.89.89,0,0,0-.45.12,1.14,1.14,0,0,0-.5,1.08V94.9a3.36,3.36,0,0,0,.5,1.65,3.25,3.25,0,0,0,1.18,1.25l9.55,5.51,11.16,6.45,9.62,5.55a1.47,1.47,0,0,0,.73.23.89.89,0,0,0,.45-.12,1.13,1.13,0,0,0,.49-1.08v-7.23a3.71,3.71,0,0,0-1.67-2.9l-9.62-5.55-11.16-6.45-9.55-5.51a1.51,1.51,0,0,0-.73-.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator-2--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.31,280.63V101.23a12.68,12.68,0,0,0-5.73-9.93L361.27,33.94c-3.16-1.83-5.73-.35-5.73,3.31v179.4a12.66,12.66,0,0,0,5.73,9.92l99.31,57.37C463.74,285.76,466.31,284.28,466.31,280.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.71,34.22a4.15,4.15,0,0,1,2,.64l99.31,57.36a11.69,11.69,0,0,1,5.2,9v179.4c0,.71-.16,3-2.11,3a4.15,4.15,0,0,1-2-.64L361.8,225.66a11.7,11.7,0,0,1-5.2-9V37.25c0-.71.16-3,2.11-3m0-1.06c-1.88,0-3.17,1.49-3.17,4.09v179.4a12.66,12.66,0,0,0,5.73,9.92l99.31,57.37a5.21,5.21,0,0,0,2.56.78c1.88,0,3.17-1.5,3.17-4.09V101.23a12.68,12.68,0,0,0-5.73-9.93L361.27,33.94a5.21,5.21,0,0,0-2.56-.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.21,33.55l-.06,0c1-.64,2.5-.58,4.13.36l99.3,57.36a11.68,11.68,0,0,1,4,4.24l10.76-6.21a11.61,11.61,0,0,0-4-4.26L372,27.7a4.07,4.07,0,0,0-4-.43C367,27.86,358.25,32.94,357.21,33.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.61,95.54a11.76,11.76,0,0,1,1.7,5.69v179.4a4.1,4.1,0,0,1-1.59,3.66c1.18-.7,9.64-5.6,10.67-6.19s1.67-1.88,1.67-3.71V95a11.73,11.73,0,0,0-1.68-5.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,84.84h0a3,3,0,0,0,1,1.07l91.77,53c.79.46,1.44.09,1.44-.83V100.89a3.17,3.17,0,0,0-1.43-2.48L398.73,64.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61,46.22V83.43a2.92,2.92,0,0,0,.41,1.41l34.71-20L366.29,46.11,365,45.39C364.25,44.93,363.61,45.31,363.61,46.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,46.11V81.88a3.16,3.16,0,0,0,1.44,2.48l90.52,52.29V100.89a3.17,3.17,0,0,0-1.43-2.48Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,46.11V81.88a3.16,3.16,0,0,0,1.44,2.48l90.52,52.29V100.89a3.17,3.17,0,0,0-1.43-2.48Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,91.93v.83a2.68,2.68,0,0,1-.63,2,1.17,1.17,0,0,1-1.53.09l-2.16-1.25a4.1,4.1,0,0,1-1.53-1.85,6.36,6.36,0,0,1-.63-2.72.67.67,0,0,1,.16-.5.29.29,0,0,1,.38,0,1,1,0,0,1,.38.47,1.5,1.5,0,0,1,.16.67,3.15,3.15,0,0,0,.32,1.36,2,2,0,0,0,.76.93l2.16,1.25a.6.6,0,0,0,.77-.05,1.32,1.32,0,0,0,.31-1v-.83a3.14,3.14,0,0,0-.31-1.36,2,2,0,0,0-.77-.93l-.54-.31a1,1,0,0,1-.38-.46,1.51,1.51,0,0,1-.16-.68.65.65,0,0,1,.16-.5.3.3,0,0,1,.38,0l.54.32a.6.6,0,0,0,.77,0,1.32,1.32,0,0,0,.31-1v-.83a3.14,3.14,0,0,0-.31-1.36,2,2,0,0,0-.77-.93L400.68,82a.57.57,0,0,0-.76,0,1.32,1.32,0,0,0-.32,1,.65.65,0,0,1-.16.5.3.3,0,0,1-.38,0,1,1,0,0,1-.38-.46,1.51,1.51,0,0,1-.16-.68,2.68,2.68,0,0,1,.63-2,1.16,1.16,0,0,1,1.53-.09l2.16,1.25a4,4,0,0,1,1.53,1.85,6.36,6.36,0,0,1,.63,2.72v.83a3.63,3.63,0,0,1-.19,1.26,1.92,1.92,0,0,1-.54.81,7.84,7.84,0,0,1,.54,1.43A6,6,0,0,1,405,91.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.22,98.43a22,22,0,0,0,.52-2.88l.85.35a14.17,14.17,0,0,1-.82,2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.27,95.87l-2.16-1.24a.57.57,0,0,0-.76,0,1.36,1.36,0,0,0-.32,1v1.24a.81.81,0,0,0,.08.34.51.51,0,0,0,.19.23l4.6,2.66a1,1,0,0,1,.38.47,1.51,1.51,0,0,1,.16.68.63.63,0,0,1-.16.49.29.29,0,0,1-.38,0l-5.41-3.12a1.07,1.07,0,0,1-.38-.46,1.65,1.65,0,0,1-.16-.68V95a2.6,2.6,0,0,1,.64-2,1.16,1.16,0,0,1,1.52-.1l2.16,1.25a.6.6,0,0,0,.77,0,1.28,1.28,0,0,0,.32-1V91.51a3.17,3.17,0,0,0-.31-1.36,2.11,2.11,0,0,0-.78-.93L411.11,88a.58.58,0,0,0-.76,0,1.32,1.32,0,0,0-.32,1,.68.68,0,0,1-.15.5.3.3,0,0,1-.38,0,1,1,0,0,1-.39-.47,1.65,1.65,0,0,1-.16-.68,2.64,2.64,0,0,1,.64-2,1.17,1.17,0,0,1,1.52-.09l2.16,1.25a4,4,0,0,1,1.54,1.86,6.32,6.32,0,0,1,.63,2.72V93.8a2.68,2.68,0,0,1-.63,2A1.18,1.18,0,0,1,413.27,95.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.68,95.25a.71.71,0,0,0,.08.34.45.45,0,0,0,.19.23l3,1.72a4,4,0,0,1,1.52,1.85,6.23,6.23,0,0,1,.64,2.72v1.66a2.64,2.64,0,0,1-.64,2,1.15,1.15,0,0,1-1.52.09l-2.16-1.24a4.07,4.07,0,0,1-1.53-1.86,6.34,6.34,0,0,1-.64-2.72.66.66,0,0,1,.17-.5.3.3,0,0,1,.38,0,1,1,0,0,1,.38.46,1.66,1.66,0,0,1,.16.69A3.13,3.13,0,0,0,419,102a2,2,0,0,0,.77.93l2.16,1.25a.57.57,0,0,0,.76,0,1.32,1.32,0,0,0,.32-1v-1.66a3.15,3.15,0,0,0-.32-1.36,2,2,0,0,0-.76-.93l-3.24-1.87a2,2,0,0,1-.77-.93,3.19,3.19,0,0,1-.32-1.36V90.88a.7.7,0,0,1,.16-.5.31.31,0,0,1,.39,0l5.4,3.12a1.13,1.13,0,0,1,.38.46,1.65,1.65,0,0,1,.16.68.67.67,0,0,1-.16.49.29.29,0,0,1-.38,0L419,92.48c-.08,0-.14,0-.19,0a.31.31,0,0,0-.08.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,107.93v.83a2.68,2.68,0,0,1-.63,2,1.16,1.16,0,0,1-1.53.09l-2.16-1.24a4.07,4.07,0,0,1-1.53-1.86,6.32,6.32,0,0,1-.63-2.72v-.83a3.73,3.73,0,0,1,.19-1.27,1.77,1.77,0,0,1,.54-.8,6.81,6.81,0,0,1-.54-1.43,6,6,0,0,1-.19-1.49v-.83a2.68,2.68,0,0,1,.63-2,1.17,1.17,0,0,1,1.53-.09l2.16,1.25a4.1,4.1,0,0,1,1.53,1.85,6.36,6.36,0,0,1,.63,2.72v.83a3.62,3.62,0,0,1-.2,1.26,1.75,1.75,0,0,1-.54.81,6.61,6.61,0,0,1,.54,1.43A6.05,6.05,0,0,1,432.72,107.93Zm-1.08-6.44a3.15,3.15,0,0,0-.32-1.36,2,2,0,0,0-.76-.93L428.4,98a.6.6,0,0,0-.77,0,1.32,1.32,0,0,0-.31,1v.83a3.14,3.14,0,0,0,.31,1.36,2,2,0,0,0,.77.93l2.16,1.25a.58.58,0,0,0,.76,0,1.32,1.32,0,0,0,.32-1Zm0,5.82a3.19,3.19,0,0,0-.32-1.36,2,2,0,0,0-.76-.93l-2.16-1.25a.6.6,0,0,0-.77,0,1.32,1.32,0,0,0-.31,1v.84a3.13,3.13,0,0,0,.31,1.35,2,2,0,0,0,.77.93l2.16,1.25a.57.57,0,0,0,.76-.05,1.32,1.32,0,0,0,.32-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.25,112.28c0-.49.21-.71.52-.54a1.34,1.34,0,0,1,.51,1.13c0,.48-.2.73-.52.54A1.34,1.34,0,0,1,434.25,112.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.15,114v.84a2.66,2.66,0,0,1-.63,2,1.16,1.16,0,0,1-1.53.09l-2.16-1.24a4.07,4.07,0,0,1-1.53-1.86,6.32,6.32,0,0,1-.63-2.72v-.83a3.71,3.71,0,0,1,.19-1.26,1.75,1.75,0,0,1,.54-.81,6.61,6.61,0,0,1-.54-1.43,6,6,0,0,1-.19-1.49v-.83a2.68,2.68,0,0,1,.63-2,1.18,1.18,0,0,1,1.53-.09l2.16,1.25a4,4,0,0,1,1.53,1.86,6.28,6.28,0,0,1,.63,2.71V109a3.72,3.72,0,0,1-.2,1.27,1.94,1.94,0,0,1-.53.81,7.06,7.06,0,0,1,.53,1.42A6.05,6.05,0,0,1,443.15,114Zm-1.08-6.44a3.19,3.19,0,0,0-.32-1.36,2,2,0,0,0-.76-.93L438.83,104a.59.59,0,0,0-.77,0,1.34,1.34,0,0,0-.31,1v.84a3.1,3.1,0,0,0,.31,1.35,2,2,0,0,0,.77.93l2.16,1.25a.57.57,0,0,0,.76,0,1.32,1.32,0,0,0,.32-1Zm0,5.82a3.19,3.19,0,0,0-.32-1.36A2,2,0,0,0,441,111l-2.16-1.24a.59.59,0,0,0-.77,0,1.36,1.36,0,0,0-.31,1v.83a3.17,3.17,0,0,0,.31,1.36,2,2,0,0,0,.77.92L441,115.2a.58.58,0,0,0,.76,0,1.36,1.36,0,0,0,.32-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.63,121.85l-2.16-1.24a4.13,4.13,0,0,1-1.53-1.86,6.32,6.32,0,0,1-.63-2.72.64.64,0,0,1,.16-.49.29.29,0,0,1,.38,0,1,1,0,0,1,.38.46,1.54,1.54,0,0,1,.16.68,3.19,3.19,0,0,0,.32,1.36,2,2,0,0,0,.76.92l2.16,1.25a.6.6,0,0,0,.77,0,1.32,1.32,0,0,0,.32-1V117a1.3,1.3,0,0,1-1.09-.18l-2.16-1.24a4.13,4.13,0,0,1-1.53-1.86,6.32,6.32,0,0,1-.63-2.72v-1.66a2.68,2.68,0,0,1,.63-2,1.18,1.18,0,0,1,1.53-.09l2.16,1.25a4.08,4.08,0,0,1,1.54,1.86,6.32,6.32,0,0,1,.63,2.72v6.65a2.68,2.68,0,0,1-.63,2A1.18,1.18,0,0,1,449.63,121.85Zm1.09-9.35a3.11,3.11,0,0,0-.32-1.35,2.07,2.07,0,0,0-.77-.94L447.47,109a.58.58,0,0,0-.76.05,1.34,1.34,0,0,0-.32,1v1.67a3.19,3.19,0,0,0,.32,1.36,2,2,0,0,0,.76.92l2.16,1.25a.6.6,0,0,0,.77,0,1.32,1.32,0,0,0,.32-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,143.28l11.08,6.4a4.86,4.86,0,0,1,2.21,3.81v6.84a1.47,1.47,0,0,1-.63,1.36l-2.77,1.6a1.47,1.47,0,0,1-1.48-.14l-11.09-6.4a4.85,4.85,0,0,1-2.2-3.81V146.1a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,444.92,143.28Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,156.75l11.09,6.4c1.21.7,2.2.13,2.2-1.27V155a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.22-.7-2.2-.13-2.2,1.27v6.84A4.85,4.85,0,0,0,442.24,156.75Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,156.75l11.09,6.4c1.21.7,2.2.13,2.2-1.27V155a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.22-.7-2.2-.13-2.2,1.27v6.84A4.85,4.85,0,0,0,442.24,156.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,144.55l2.42-1.4a1.48,1.48,0,0,1,1.5.13L456,149.69a4.41,4.41,0,0,1,1.56,1.64l-2.69,1.55a4.39,4.39,0,0,0-1.55-1.64l-11.09-6.41A1.85,1.85,0,0,0,441,144.55Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,144.55l2.42-1.4a1.48,1.48,0,0,1,1.5.13L456,149.69a4.41,4.41,0,0,1,1.56,1.64l-2.69,1.55a4.39,4.39,0,0,0-1.55-1.64l-11.09-6.41A1.85,1.85,0,0,0,441,144.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1,128.37l11.09,6.4a4.88,4.88,0,0,1,2.2,3.81v6.84a1.47,1.47,0,0,1-.63,1.36l-2.77,1.6a1.45,1.45,0,0,1-1.48-.14l-11.09-6.4a4.88,4.88,0,0,1-2.2-3.81v-6.84a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,419.1,128.37Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.42,141.84l11.09,6.4c1.21.7,2.2.13,2.2-1.27v-6.84a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.27V138A4.88,4.88,0,0,0,416.42,141.84Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.42,141.84l11.09,6.4c1.21.7,2.2.13,2.2-1.27v-6.84a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.27V138A4.88,4.88,0,0,0,416.42,141.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,129.64l2.42-1.4a1.5,1.5,0,0,1,1.51.13l11.08,6.41a4.34,4.34,0,0,1,1.56,1.64L429.07,138a4.49,4.49,0,0,0-1.56-1.64l-11.09-6.41A1.84,1.84,0,0,0,415.18,129.64Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,129.64l2.42-1.4a1.5,1.5,0,0,1,1.51.13l11.08,6.41a4.34,4.34,0,0,1,1.56,1.64L429.07,138a4.49,4.49,0,0,0-1.56-1.64l-11.09-6.41A1.84,1.84,0,0,0,415.18,129.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,113.46l11.09,6.4a4.85,4.85,0,0,1,2.2,3.82v6.83a1.45,1.45,0,0,1-.63,1.36l-2.76,1.6a1.47,1.47,0,0,1-1.49-.14l-11.08-6.4a4.86,4.86,0,0,1-2.21-3.81v-6.84a1.49,1.49,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,393.28,113.46Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,126.93l11.08,6.4c1.22.7,2.2.13,2.2-1.27v-6.84a4.85,4.85,0,0,0-2.2-3.81L390.61,115c-1.22-.7-2.21-.13-2.21,1.27v6.84A4.86,4.86,0,0,0,390.61,126.93Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,126.93l11.08,6.4c1.22.7,2.2.13,2.2-1.27v-6.84a4.85,4.85,0,0,0-2.2-3.81L390.61,115c-1.22-.7-2.21-.13-2.21,1.27v6.84A4.86,4.86,0,0,0,390.61,126.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,114.73l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.41a4.39,4.39,0,0,1,1.55,1.64l-2.68,1.55a4.41,4.41,0,0,0-1.56-1.64L390.61,115A1.86,1.86,0,0,0,389.37,114.73Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,114.73l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.41a4.39,4.39,0,0,1,1.55,1.64l-2.68,1.55a4.41,4.41,0,0,0-1.56-1.64L390.61,115A1.86,1.86,0,0,0,389.37,114.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.47,98.55l11.08,6.4a4.83,4.83,0,0,1,2.2,3.82v6.83a1.45,1.45,0,0,1-.64,1.36c-.1.07-2.65,1.54-2.76,1.6a1.47,1.47,0,0,1-1.49-.14L364.79,112a4.85,4.85,0,0,1-2.2-3.81v-6.84a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,367.47,98.55Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,112l11.08,6.4c1.22.7,2.21.14,2.21-1.27v-6.84a4.86,4.86,0,0,0-2.21-3.81l-11.08-6.4c-1.22-.7-2.2-.13-2.2,1.27v6.84A4.85,4.85,0,0,0,364.79,112Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,112l11.08,6.4c1.22.7,2.21.14,2.21-1.27v-6.84a4.86,4.86,0,0,0-2.21-3.81l-11.08-6.4c-1.22-.7-2.2-.13-2.2,1.27v6.84A4.85,4.85,0,0,0,364.79,112Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,99.82l2.42-1.4a1.48,1.48,0,0,1,1.5.13L378.56,105a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.47,4.47,0,0,0-1.55-1.64l-11.09-6.41A1.91,1.91,0,0,0,363.55,99.82Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,99.82l2.42-1.4a1.48,1.48,0,0,1,1.5.13L378.56,105a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.47,4.47,0,0,0-1.55-1.64l-11.09-6.41A1.91,1.91,0,0,0,363.55,99.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,246.2,456,252.6a4.88,4.88,0,0,1,2.2,3.81v12.87a1.48,1.48,0,0,1-.63,1.36l-2.77,1.59a1.47,1.47,0,0,1-1.48-.13l-11.09-6.4a4.9,4.9,0,0,1-2.2-3.82V249a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,444.92,246.2Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,246.2,456,252.6a4.88,4.88,0,0,1,2.2,3.81v12.87a1.48,1.48,0,0,1-.63,1.36l-2.77,1.59a1.47,1.47,0,0,1-1.48-.13l-11.09-6.4a4.9,4.9,0,0,1-2.2-3.82V249a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,444.92,246.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,265.7l11.09,6.4c1.21.7,2.2.13,2.2-1.28V258a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.27v12.86A4.9,4.9,0,0,0,442.24,265.7Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,247.47l2.41-1.4a1.5,1.5,0,0,1,1.51.13L456,252.61a4.34,4.34,0,0,1,1.56,1.64l-2.68,1.55a4.49,4.49,0,0,0-1.56-1.64l-11.09-6.41A1.82,1.82,0,0,0,441,247.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,219.44l11.09,6.4a4.86,4.86,0,0,1,2.2,3.81v12.86a1.48,1.48,0,0,1-.63,1.36l-2.77,1.6a1.47,1.47,0,0,1-1.48-.14l-11.09-6.4a4.85,4.85,0,0,1-2.2-3.81V222.25a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.47,1.47,0,0,1,444.92,219.44Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,219.44l11.09,6.4a4.86,4.86,0,0,1,2.2,3.81v12.86a1.48,1.48,0,0,1-.63,1.36l-2.77,1.6a1.47,1.47,0,0,1-1.48-.14l-11.09-6.4a4.85,4.85,0,0,1-2.2-3.81V222.25a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.47,1.47,0,0,1,444.92,219.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,238.93l11.09,6.4c1.21.7,2.2.13,2.2-1.27V231.2a4.88,4.88,0,0,0-2.2-3.82L442.24,221c-1.22-.7-2.2-.13-2.2,1.27v12.87A4.88,4.88,0,0,0,442.24,238.93Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,220.7l2.42-1.39a1.46,1.46,0,0,1,1.5.13l11.09,6.4a4.37,4.37,0,0,1,1.56,1.65L454.88,229a4.39,4.39,0,0,0-1.55-1.64L442.24,221A1.91,1.91,0,0,0,441,220.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,192.67l11.08,6.4a4.85,4.85,0,0,1,2.2,3.81v12.86a1.45,1.45,0,0,1-.64,1.36c-.1.07-2.65,1.54-2.76,1.6a1.47,1.47,0,0,1-1.49-.14l-11.08-6.4a4.85,4.85,0,0,1-2.2-3.81V195.49a1.45,1.45,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,444.92,192.67Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,192.67l11.08,6.4a4.85,4.85,0,0,1,2.2,3.81v12.86a1.45,1.45,0,0,1-.64,1.36c-.1.07-2.65,1.54-2.76,1.6a1.47,1.47,0,0,1-1.49-.14l-11.08-6.4a4.85,4.85,0,0,1-2.2-3.81V195.49a1.45,1.45,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,444.92,192.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,212.16l11.08,6.4c1.22.7,2.21.14,2.21-1.27V204.43a4.85,4.85,0,0,0-2.21-3.81l-11.08-6.4c-1.22-.71-2.2-.14-2.2,1.27v12.86A4.85,4.85,0,0,0,442.24,212.16Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,193.94l2.42-1.4a1.48,1.48,0,0,1,1.5.13L456,199.08a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.42,4.42,0,0,0-1.55-1.65l-11.09-6.4A1.85,1.85,0,0,0,441,193.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,165.9,456,172.3a4.85,4.85,0,0,1,2.2,3.82V189a1.46,1.46,0,0,1-.63,1.36l-2.76,1.59a1.46,1.46,0,0,1-1.49-.13l-11.08-6.4a4.87,4.87,0,0,1-2.2-3.82V168.72a1.49,1.49,0,0,1,.62-1.35l2.77-1.6A1.48,1.48,0,0,1,444.92,165.9Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92,165.9,456,172.3a4.85,4.85,0,0,1,2.2,3.82V189a1.46,1.46,0,0,1-.63,1.36l-2.76,1.59a1.46,1.46,0,0,1-1.49-.13l-11.08-6.4a4.87,4.87,0,0,1-2.2-3.82V168.72a1.49,1.49,0,0,1,.62-1.35l2.77-1.6A1.48,1.48,0,0,1,444.92,165.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.24,185.4l11.08,6.4c1.22.7,2.2.13,2.2-1.27V177.66a4.85,4.85,0,0,0-2.2-3.81l-11.08-6.4c-1.22-.7-2.21-.13-2.21,1.27v12.86A4.87,4.87,0,0,0,442.24,185.4Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,167.17l2.42-1.4a1.48,1.48,0,0,1,1.5.13L456,172.31a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.41,4.41,0,0,0-1.56-1.64l-11.08-6.41A1.92,1.92,0,0,0,441,167.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,216.54l11.08,6.4a4.86,4.86,0,0,1,2.21,3.81v12.87a1.45,1.45,0,0,1-.63,1.35l-2.77,1.6a1.47,1.47,0,0,1-1.49-.14L390.53,236a4.85,4.85,0,0,1-2.2-3.81V219.36A1.45,1.45,0,0,1,389,218l2.77-1.6A1.46,1.46,0,0,1,393.21,216.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,236l11.08,6.4c1.22.71,2.21.14,2.21-1.27V228.3a4.86,4.86,0,0,0-2.21-3.81l-11.08-6.4c-1.22-.7-2.2-.14-2.2,1.27v12.86A4.85,4.85,0,0,0,390.53,236Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,218.85a.9.9,0,0,1,.45.16l11.08,6.4a3.81,3.81,0,0,1,1.68,2.89v12.86c0,.35-.1.49-.16.51a.85.85,0,0,1-.45-.16l-11.09-6.4a3.8,3.8,0,0,1-1.67-2.89V219.36a.83.83,0,0,1,.11-.51h.05m0-1.06c-.73,0-1.22.57-1.22,1.57v12.86a4.85,4.85,0,0,0,2.2,3.81l11.08,6.4a2,2,0,0,0,1,.3c.72,0,1.22-.57,1.22-1.57V228.3a4.86,4.86,0,0,0-2.21-3.81l-11.08-6.4a1.93,1.93,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,217.81l2.42-1.4a1.48,1.48,0,0,1,1.5.13L404.3,223a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.49,4.49,0,0,0-1.55-1.65l-11.09-6.4A1.85,1.85,0,0,0,389.29,217.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,217.81,389,218a1.26,1.26,0,0,0-.59.87A1.18,1.18,0,0,1,389.29,217.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,204.61l11.08,6.4a4.88,4.88,0,0,1,2.21,3.82v12.86a1.48,1.48,0,0,1-.63,1.36L429,230.64a1.44,1.44,0,0,1-1.48-.13l-11.09-6.4a4.85,4.85,0,0,1-2.2-3.81V207.43a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,419.07,204.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,224.11l11.09,6.4c1.21.7,2.2.13,2.2-1.27V216.37a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.22-.7-2.2-.13-2.2,1.27V220.3A4.85,4.85,0,0,0,416.39,224.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,206.92a1,1,0,0,1,.45.16l11.08,6.4a3.82,3.82,0,0,1,1.68,2.89v12.87c0,.34-.09.49-.16.51a1,1,0,0,1-.45-.16l-11.09-6.4a3.81,3.81,0,0,1-1.67-2.89V207.43c0-.35.09-.49.11-.5h.05m0-1.06c-.73,0-1.22.58-1.22,1.57V220.3a4.85,4.85,0,0,0,2.2,3.81l11.09,6.4a2,2,0,0,0,1,.3c.72,0,1.22-.58,1.22-1.57V216.37a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4a2,2,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,205.88l2.42-1.39a1.46,1.46,0,0,1,1.5.13l11.09,6.4a4.49,4.49,0,0,1,1.56,1.64L429,214.21a4.39,4.39,0,0,0-1.55-1.64l-11.09-6.4A1.92,1.92,0,0,0,415.15,205.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,205.88l-.32.19a1.28,1.28,0,0,0-.59.87A1.21,1.21,0,0,1,415.15,205.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,189.77l11.08,6.4a4.87,4.87,0,0,1,2.2,3.82v12.86a1.46,1.46,0,0,1-.63,1.36l-2.76,1.59a1.46,1.46,0,0,1-1.49-.13l-11.08-6.4a4.85,4.85,0,0,1-2.2-3.82V192.59a1.49,1.49,0,0,1,.61-1.35l2.78-1.6A1.46,1.46,0,0,1,393.21,189.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,209.27l11.08,6.4c1.22.7,2.2.13,2.2-1.27V201.53a4.85,4.85,0,0,0-2.2-3.81l-11.08-6.4c-1.22-.7-2.2-.13-2.2,1.27v12.86A4.85,4.85,0,0,0,390.53,209.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,192.08a1,1,0,0,1,.46.16l11.08,6.4a3.81,3.81,0,0,1,1.67,2.89V214.4c0,.34-.09.48-.15.51a1,1,0,0,1-.46-.16l-11.08-6.4a3.83,3.83,0,0,1-1.67-2.9V192.59c0-.35.09-.49.11-.5h0m0-1.06c-.72,0-1.21.58-1.21,1.57v12.86a4.85,4.85,0,0,0,2.2,3.82l11.08,6.4a2.07,2.07,0,0,0,1,.3c.72,0,1.21-.58,1.21-1.57V201.53a4.85,4.85,0,0,0-2.2-3.81l-11.08-6.4a2.07,2.07,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,191l2.42-1.39a1.46,1.46,0,0,1,1.5.13l11.09,6.4a4.32,4.32,0,0,1,1.55,1.64l-2.68,1.55a4.41,4.41,0,0,0-1.56-1.64l-11.08-6.41A1.92,1.92,0,0,0,389.29,191Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,191l-.32.19a1.29,1.29,0,0,0-.6.87A1.21,1.21,0,0,1,389.29,191Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,174.93l11.08,6.4a4.85,4.85,0,0,1,2.2,3.82V198a1.46,1.46,0,0,1-.63,1.36L377.24,201a1.49,1.49,0,0,1-1.49-.13l-11.08-6.4a4.84,4.84,0,0,1-2.2-3.82V177.75a1.49,1.49,0,0,1,.62-1.35l2.77-1.6A1.48,1.48,0,0,1,367.35,174.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,194.43l11.08,6.4c1.22.7,2.2.13,2.2-1.27V186.69a4.85,4.85,0,0,0-2.2-3.81l-11.08-6.4c-1.22-.7-2.21-.13-2.21,1.27v12.86A4.88,4.88,0,0,0,364.67,194.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,177.24a1,1,0,0,1,.46.16l11.08,6.4a3.8,3.8,0,0,1,1.67,2.89v12.87c0,.34-.09.48-.15.51a1,1,0,0,1-.46-.16l-11.08-6.4a3.83,3.83,0,0,1-1.67-2.9V177.75a.83.83,0,0,1,.11-.51h0m0-1.06c-.72,0-1.22.57-1.22,1.57v12.86a4.88,4.88,0,0,0,2.21,3.82l11.08,6.4a2.07,2.07,0,0,0,1,.3c.72,0,1.21-.58,1.21-1.57V186.69a4.85,4.85,0,0,0-2.2-3.81l-11.08-6.4a2.07,2.07,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,176.2l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.41A4.32,4.32,0,0,1,380,183l-2.68,1.55a4.41,4.41,0,0,0-1.56-1.64l-11.08-6.41A1.92,1.92,0,0,0,363.43,176.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,176.2l-.32.19a1.29,1.29,0,0,0-.6.87A1.21,1.21,0,0,1,363.43,176.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,177.85l11.08,6.4a4.85,4.85,0,0,1,2.2,3.81v12.86a1.45,1.45,0,0,1-.63,1.36l-2.76,1.6a1.49,1.49,0,0,1-1.49-.14l-11.08-6.4a4.86,4.86,0,0,1-2.21-3.81V180.67a1.47,1.47,0,0,1,.62-1.35c.11-.07,2.67-1.54,2.77-1.61A1.49,1.49,0,0,1,419.07,177.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,197.34l11.08,6.4c1.22.7,2.2.13,2.2-1.27V189.61a4.87,4.87,0,0,0-2.2-3.82l-11.08-6.39c-1.22-.71-2.21-.14-2.21,1.27v12.86A4.86,4.86,0,0,0,416.39,197.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.4,180.16a.94.94,0,0,1,.46.15l11.08,6.4a3.83,3.83,0,0,1,1.67,2.9v12.86c0,.35-.09.49-.16.51a.9.9,0,0,1-.45-.16l-11.08-6.4a3.8,3.8,0,0,1-1.67-2.89V180.67a.87.87,0,0,1,.12-.51h0m0-1.07c-.72,0-1.22.58-1.22,1.58v12.86a4.86,4.86,0,0,0,2.21,3.81l11.08,6.4a1.93,1.93,0,0,0,1,.3c.73,0,1.22-.57,1.22-1.57V189.61a4.87,4.87,0,0,0-2.2-3.82l-11.08-6.39a2,2,0,0,0-1-.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,179.12l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.4a4.35,4.35,0,0,1,1.55,1.65L429,187.45a4.37,4.37,0,0,0-1.56-1.65l-11.08-6.4A1.86,1.86,0,0,0,415.15,179.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,179.12l-.32.18a1.31,1.31,0,0,0-.6.87A1.19,1.19,0,0,1,415.15,179.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2,163l11.09,6.4a4.85,4.85,0,0,1,2.2,3.81v12.86a1.45,1.45,0,0,1-.63,1.36L403.1,189a1.49,1.49,0,0,1-1.49-.14l-11.09-6.4a4.88,4.88,0,0,1-2.2-3.81V165.82a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.47,1.47,0,0,1,393.2,163Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.52,182.5l11.09,6.4c1.22.7,2.2.13,2.2-1.27V174.77a4.87,4.87,0,0,0-2.2-3.82l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.28v12.86A4.88,4.88,0,0,0,390.52,182.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,165.31a1,1,0,0,1,.45.16l11.09,6.4a3.83,3.83,0,0,1,1.67,2.9v12.86c0,.35-.09.49-.16.51a1,1,0,0,1-.45-.16l-11.08-6.4a3.81,3.81,0,0,1-1.68-2.89V165.83a.79.79,0,0,1,.12-.51h0m0-1.06c-.72,0-1.22.58-1.22,1.58v12.86a4.86,4.86,0,0,0,2.21,3.81l11.08,6.4a2,2,0,0,0,1,.3c.73,0,1.22-.57,1.22-1.57V174.77a4.87,4.87,0,0,0-2.2-3.82l-11.09-6.4a2,2,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,164.28l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.4a4.42,4.42,0,0,1,1.55,1.65l-2.68,1.55a4.37,4.37,0,0,0-1.56-1.65l-11.08-6.4A1.86,1.86,0,0,0,389.29,164.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29,164.28l-.33.18a1.31,1.31,0,0,0-.59.87A1.19,1.19,0,0,1,389.29,164.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,148.17l11.09,6.4a4.86,4.86,0,0,1,2.2,3.81v12.86a1.47,1.47,0,0,1-.63,1.36l-2.76,1.6a1.49,1.49,0,0,1-1.49-.14l-11.09-6.4a4.88,4.88,0,0,1-2.2-3.81V151a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.47,1.47,0,0,1,367.34,148.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,167.66l11.09,6.4c1.22.7,2.2.13,2.2-1.27V159.93a4.85,4.85,0,0,0-2.2-3.82l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.27v12.87A4.88,4.88,0,0,0,364.66,167.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,150.47a1,1,0,0,1,.45.16l11.09,6.4a3.83,3.83,0,0,1,1.67,2.9v12.86c0,.35-.09.49-.16.51a1,1,0,0,1-.45-.16l-11.09-6.4a3.81,3.81,0,0,1-1.67-2.89V151c0-.34.09-.48.12-.5h0m0-1.06c-.72,0-1.22.58-1.22,1.57v12.87a4.88,4.88,0,0,0,2.2,3.81l11.09,6.4a2,2,0,0,0,1,.3c.73,0,1.22-.58,1.22-1.57V159.93a4.88,4.88,0,0,0-2.2-3.82l-11.09-6.4a2,2,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,149.44l2.42-1.4a1.46,1.46,0,0,1,1.5.13l11.08,6.4a4.37,4.37,0,0,1,1.56,1.65l-2.68,1.55a4.44,4.44,0,0,0-1.56-1.65l-11.09-6.4A1.82,1.82,0,0,0,363.43,149.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,149.44l-.33.18a1.31,1.31,0,0,0-.59.87A1.19,1.19,0,0,1,363.43,149.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.06,151.08l11.09,6.4a4.88,4.88,0,0,1,2.2,3.81v12.87a1.48,1.48,0,0,1-.63,1.36L429,177.11a1.49,1.49,0,0,1-1.49-.13l-11.09-6.4a4.9,4.9,0,0,1-2.2-3.82V153.9a1.47,1.47,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,419.06,151.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.38,170.58l11.09,6.4c1.22.7,2.2.13,2.2-1.28V162.84a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.21-.7-2.2-.13-2.2,1.27v12.86A4.9,4.9,0,0,0,416.38,170.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.4,153.39a.87.87,0,0,1,.45.16l11.09,6.4a3.8,3.8,0,0,1,1.67,2.89V175.7c0,.35-.09.49-.16.51a1,1,0,0,1-.45-.15l-11.09-6.4a3.83,3.83,0,0,1-1.67-2.9V153.9c0-.35.09-.49.12-.51h0m0-1.06c-.72,0-1.22.57-1.22,1.57v12.86a4.9,4.9,0,0,0,2.2,3.82l11.09,6.4a2,2,0,0,0,1,.3c.72,0,1.22-.58,1.22-1.58V162.84a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4a1.9,1.9,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,152.35l2.41-1.4a1.5,1.5,0,0,1,1.51.13l11.08,6.41a4.34,4.34,0,0,1,1.56,1.64L429,160.68a4.49,4.49,0,0,0-1.56-1.64l-11.09-6.41A1.82,1.82,0,0,0,415.15,152.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,152.35l-.33.19a1.31,1.31,0,0,0-.59.87A1.21,1.21,0,0,1,415.15,152.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2,136.24l11.09,6.4a4.88,4.88,0,0,1,2.2,3.81v12.87a1.45,1.45,0,0,1-.63,1.35l-2.77,1.6a1.45,1.45,0,0,1-1.48-.14l-11.09-6.4a4.86,4.86,0,0,1-2.2-3.81V139.06a1.46,1.46,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,393.2,136.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.52,155.73l11.09,6.4c1.21.71,2.2.14,2.2-1.27V148a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4c-1.21-.7-2.2-.14-2.2,1.27v12.86A4.86,4.86,0,0,0,390.52,155.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,138.55a.9.9,0,0,1,.45.16l11.09,6.4a3.8,3.8,0,0,1,1.67,2.89v12.86c0,.35-.09.49-.16.51a1,1,0,0,1-.45-.15l-11.09-6.4a3.83,3.83,0,0,1-1.67-2.9V139.06a.83.83,0,0,1,.11-.51h.05m0-1.06c-.72,0-1.22.57-1.22,1.57v12.86a4.86,4.86,0,0,0,2.2,3.81l11.09,6.4a1.93,1.93,0,0,0,1,.3c.72,0,1.22-.57,1.22-1.57V148a4.88,4.88,0,0,0-2.2-3.81l-11.09-6.4a1.9,1.9,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,137.51l2.42-1.4a1.5,1.5,0,0,1,1.51.13l11.08,6.41a4.34,4.34,0,0,1,1.56,1.64l-2.68,1.55a4.49,4.49,0,0,0-1.56-1.64l-11.09-6.41A1.84,1.84,0,0,0,389.28,137.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,137.51l-.32.19a1.31,1.31,0,0,0-.59.87A1.22,1.22,0,0,1,389.28,137.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,201.7l11.08,6.4a4.85,4.85,0,0,1,2.2,3.81v12.86a1.47,1.47,0,0,1-.64,1.36c-.1.07-2.65,1.54-2.76,1.6a1.47,1.47,0,0,1-1.49-.14l-11.08-6.4a4.85,4.85,0,0,1-2.2-3.81V204.52a1.45,1.45,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,367.35,201.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,221.19l11.08,6.4c1.22.7,2.21.14,2.21-1.27V213.46a4.84,4.84,0,0,0-2.2-3.81l-11.08-6.4c-1.22-.71-2.2-.14-2.2,1.27v12.86A4.85,4.85,0,0,0,364.67,221.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,203l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.4a4.42,4.42,0,0,1,1.55,1.65l-2.68,1.55a4.42,4.42,0,0,0-1.55-1.65l-11.09-6.4A1.85,1.85,0,0,0,363.43,203Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,121.4l11.09,6.4a4.88,4.88,0,0,1,2.2,3.81v12.87a1.45,1.45,0,0,1-.63,1.35l-2.77,1.6a1.45,1.45,0,0,1-1.48-.14l-11.09-6.4a4.88,4.88,0,0,1-2.2-3.81V124.22a1.45,1.45,0,0,1,.62-1.35l2.77-1.6A1.46,1.46,0,0,1,367.34,121.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,140.89l11.09,6.4c1.21.71,2.2.14,2.2-1.27V133.16a4.88,4.88,0,0,0-2.2-3.81L364.66,123c-1.21-.71-2.2-.14-2.2,1.27v12.86A4.88,4.88,0,0,0,364.66,140.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,123.71a.9.9,0,0,1,.45.16l11.09,6.4a3.8,3.8,0,0,1,1.67,2.89V146c0,.35-.09.49-.16.51a.9.9,0,0,1-.45-.16L365.19,140a3.8,3.8,0,0,1-1.67-2.89V124.22a.83.83,0,0,1,.11-.51h.05m0-1.06c-.72,0-1.22.57-1.22,1.57v12.86a4.88,4.88,0,0,0,2.2,3.81l11.09,6.4a1.9,1.9,0,0,0,1,.3c.72,0,1.22-.57,1.22-1.57V133.16a4.88,4.88,0,0,0-2.2-3.81L364.66,123a1.93,1.93,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,122.67l2.42-1.4a1.5,1.5,0,0,1,1.51.13l11.08,6.41a4.34,4.34,0,0,1,1.56,1.64L377.3,131a4.42,4.42,0,0,0-1.55-1.65L364.66,123A1.84,1.84,0,0,0,363.42,122.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,122.67l-.32.18a1.34,1.34,0,0,0-.59.87A1.2,1.2,0,0,1,363.42,122.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,229.78l11.08,6.4a4.86,4.86,0,0,1,2.21,3.81v12.86a1.47,1.47,0,0,1-.63,1.36l-2.77,1.6a1.47,1.47,0,0,1-1.48-.14l-11.09-6.4a4.85,4.85,0,0,1-2.2-3.81V232.6a1.48,1.48,0,0,1,.62-1.36l2.77-1.6A1.47,1.47,0,0,1,419.07,229.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,249.27l11.09,6.4c1.21.7,2.2.13,2.2-1.27V241.54a4.9,4.9,0,0,0-2.2-3.82l-11.09-6.4c-1.22-.7-2.2-.13-2.2,1.28v12.86A4.85,4.85,0,0,0,416.39,249.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,232.08a1,1,0,0,1,.45.16l11.08,6.4a3.84,3.84,0,0,1,1.68,2.9V254.4c0,.35-.09.49-.16.51a1,1,0,0,1-.45-.16l-11.09-6.4a3.8,3.8,0,0,1-1.67-2.89V232.6a.83.83,0,0,1,.11-.51h.05m0-1.06c-.73,0-1.22.58-1.22,1.58v12.86a4.85,4.85,0,0,0,2.2,3.81l11.09,6.4a2,2,0,0,0,1,.3c.72,0,1.22-.57,1.22-1.57V241.54a4.9,4.9,0,0,0-2.2-3.82l-11.09-6.4a2,2,0,0,0-1-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,231.05l2.42-1.4a1.48,1.48,0,0,1,1.5.13l11.09,6.4a4.45,4.45,0,0,1,1.56,1.65L429,239.38a4.34,4.34,0,0,0-1.55-1.65l-11.09-6.4A1.85,1.85,0,0,0,415.15,231.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,231.05l-.32.18a1.28,1.28,0,0,0-.59.87A1.18,1.18,0,0,1,415.15,231.05Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.13,331.39c.25-3.34-2.39-7.16-8.29-11.68-10.88-8.36-50.41-35.85-65.77-46a.15.15,0,0,0-.12-.14c-11.76-8.49-14.4-66.64-20.8-94.46-.06-.26-.5-2.39-1.39-5.14,0-.12-.09-.24-.13-.37-.12-.37-.26-.75-.4-1.14-.07-.19-.13-.39-.2-.58h0a26.11,26.11,0,0,0-5.06-8.71,12.38,12.38,0,0,0-2.64-2.19c-1.33-.9-4.57-2.52-5.26-3-8-5.7-28.29,8.75-42.62,15.17-8.91,4-16.63,9-21.89,19h0a60.14,60.14,0,0,0-5.74,18.32c-2.35,14.21-1.88,61.91-.63,82.86h0c1.45,34.95,6.6,35.42,13.65,41.82,12.1,11,47.65,33.5,59.52,39.3,21.52,10.51,40.75-1.52,54.82-7.13s40.72-18.66,46.75-22.34c3.57-2.2,5.53-4.55,5.7-7.17C206.68,336.74,207,332.49,207.13,331.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.67,360.86c14.07-5.61,40.72-18.67,46.75-22.36,8.14-5,7.89-10.75-2.57-18.79-14.54-11.17-74.2-51.61-74.2-51.61s-69.36,33.42-85.8,48c-2.49,2.21-2.59,6.88-1.72,8,9,11.26,49.11,37.25,62.72,43.9C121.37,378.49,140.61,366.46,154.67,360.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,161a1.64,1.64,0,0,0-.22-.14A12.33,12.33,0,0,0,96.15,159c-7.27-.58-18.75,4.5-35.93,15.61a93.94,93.94,0,0,0-14.74,11.25l-.26.26a34.12,34.12,0,0,0-3.77,4.22c-.2.24-.38.49-.56.75s-.22.29-.31.43c-.24.34-.48.68-.7,1-.45.69-.89,1.42-1.33,2.17,0,.08-.09.16-.13.24l-.49.92,0,0-5.34-3.69c5.26-10,13.34-15.17,21.65-20.27,14.33-8.79,30.3-20.21,40.46-15.28C95.43,157,101,160.06,102.32,161Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,179.08c-.92-3.67-4.14-19.49-16-20.12-7.26-.58-18.75,4.51-35.93,15.61-8,5.16-17.23,11.79-21.8,20.35-6.74,10.64-7.79,40.15-7.39,68.53s2.23,55.64,6.07,60.66c6.75-18.93,86.51-56.2,95.85-50.57C121.19,265.05,118.55,206.9,112.15,179.08Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.26,267.55c-1.08,16.06-1.36,36.9.53,44.66,2.32,9.5,8.09,21.13,26.21,31.79,25.76,15.16,43.68,25.22,43.68,25.22l91-59.29-62-36.11Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.26,267.55c-1.08,16.06-1.36,36.9.53,44.66,2.32,9.5,8.09,21.13,26.21,31.79,25.76,15.16,43.68,25.22,43.68,25.22l91-59.29-62-36.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M90.2,326.75c-.69-.76-1.36-1.51-2-2.26,6.42-1.71,10.21-9.69,9.41-18.71-.46-5.17-1-11-.28-16.58l-1.13-.14c-.71,5.67-.19,11.6.28,16.82.8,9.1-3,16.45-9.11,17.64C75.05,308.77,77,294.45,83,275.44l-1.08-.34c-6.57,20.84-7.57,36.13,7.49,52.42,9.9,10.7,36.9,25.31,52.69,35.05l1.06-.68C127.36,352.2,100.12,337.47,90.2,326.75Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.09,296.2c-3.44,11.06-10.59,16.33-10.59,16.33,13.38,9.74,24.34,18.78,32,25.42l9.35-6-32.85-22C160.83,302.07,159.09,296.2,159.09,296.2Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-589"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.56 478.45 54.74 380.41 315.7 229.85 485.51 327.89 224.56 478.45",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.56 478.45 54.74 380.41 315.7 229.85 485.51 327.89 224.56 478.45",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.74 380.41 54.74 392.67 224.56 490.71 224.56 478.45 54.74 380.41",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.74 380.41 54.74 392.67 224.56 490.71 224.56 478.45 54.74 380.41",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.56 490.71 485.51 340.15 485.51 327.89 224.56 478.45 224.56 490.71",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.56 478.45 485.51 327.89 485.51 340.15 224.56 490.71 224.56 478.45",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-589",
    d: "M187.76,330.37,228,353.71a4.85,4.85,0,0,0,4.39,0L348,287.08a1.34,1.34,0,0,0,0-2.53L307.71,261.2a4.83,4.83,0,0,0-4.38,0L187.76,327.83A1.34,1.34,0,0,0,187.76,330.37Z",
    style: {
      fill: "#E68072",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.27,281.11a1.51,1.51,0,0,0-.89-1.24l-36-20.8a4.73,4.73,0,0,0-4.29,0L192.14,322.64a1.51,1.51,0,0,0-.89,1.24v3.78a1.51,1.51,0,0,0,.9,1.24l36,20.79a4.79,4.79,0,0,0,4.3,0l109.93-63.47a1.53,1.53,0,0,0,.89-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,345.82l-36-20.7a1.31,1.31,0,0,1,0-2.48l109.92-63.56a4.73,4.73,0,0,1,4.29,0l36,20.8a1.31,1.31,0,0,1,0,2.48L232.45,345.81A4.76,4.76,0,0,1,228.15,345.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,346.33v3.86a4.4,4.4,0,0,1-2-.5l-36-20.79a1.52,1.52,0,0,1-.89-1.24v-3.79a1.51,1.51,0,0,0,.89,1.24l36,20.71A4.41,4.41,0,0,0,230.16,346.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.94,262.35l.08,0,3.57,2.06-4.84,2.79-3.68-2.07,4.83-2.79Zm5.58,3.23h.08l3.57,2.06-3.8,2.19-3.69-2.07,3.8-2.19Zm-12.33.68h.07l3.57,2.06-3.8,2.19-3.68-2.07,3.79-2.19Zm17.91,2.54h.09l3.56,2.06-6.14,3.54-3.68-2.07,6.13-3.54Zm-11.29.08h.07l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm-12.34.68h.08l3.56,2.06-3.8,2.19-3.68-2.07,3.79-2.19Zm7.4,2.17H299l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm21.82.29a.13.13,0,0,1,.08,0l3.56,2-4.84,2.8-3.68-2.08,4.83-2.79Zm-34.94.84h.08l3.56,2.06L262,290.78l-3.69-2.08,27.44-15.84Zm21.3.59.08,0,3.56,2-3,1.74L304,275.19l3-1.74Zm-13.12,1.13H294l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm32.34.66.08,0,3.56,2.06-3,1.74L323.21,277l3-1.74Zm-12.34.68.08,0,3.56,2.05-3,1.75-3.69-2.07,3-1.74Zm-11.82.38.08,0,3.57,2.05-3,1.75L299.05,278l3-1.73ZM289,277.43l.08,0,3.57,2.05-3,1.74-3.69-2.07,3-1.74Zm32.34.67h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm-12.34.67.08,0,3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm-11.82.38.08,0,3.57,2.06-3,1.74-3.69-2.08,3-1.73Zm35.87,0,.08,0,3.57,2.06-3.8,2.19-3.69-2.07,3.8-2.19Zm-49,1.13a.14.14,0,0,1,.09,0l3.56,2.05-3,1.75L281,282l3-1.73Zm32.34.67h.08L320,283l-3,1.74-3.69-2.07,3-1.74Zm-12.34.67.08,0,3.57,2.06-3,1.74L301,283.37l3-1.74Zm-11.82.38.08,0,3.57,2.06-3,1.74-3.69-2.08,3-1.73Zm-13.11,1.13.08,0,3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm46.05.57h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-13.72.1h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-12.34.68h.08l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm-11.82.37a.14.14,0,0,1,.09,0l3.56,2.06-3,1.74-3.68-2.07,3-1.74ZM274.18,286l.08,0,3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm46.05.57h.09l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-13.71.1h.07l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm-12.34.68h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-11.82.37.08,0,3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-13.12,1.14h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm46.06.56h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-13.72.1h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-45.2.31.08,0,3.57,2.06-3.8,2.19L252.54,292l3.8-2.19Zm32.86.37h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm-11.82.38h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-13.12,1.13h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm46.06.56h.08l3.56,2.06-3,1.74L307.3,294l3-1.74Zm-13.72.1h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74ZM284.3,293h.08L288,295.1l-3,1.74-3.69-2.07,3-1.74Zm-33.64.08a.14.14,0,0,1,.09,0l3.56,2.06-3.8,2.19-3.68-2.07,3.79-2.19Zm21.82.3h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-13.12,1.13h.09l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm32.34.66h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-12.34.68h.08L283,298l-3,1.74-3.68-2.07,3-1.74Zm-11.82.38h.08l3.57,2.06-3,1.74L264.49,298l3-1.74Zm35.73.08h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-58.32.08H245l3.56,2.06-3.8,2.19-3.68-2.07,3.79-2.19Zm9.48,1h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm32.33.66a.14.14,0,0,1,.09,0l3.56,2.05-3,1.75-3.69-2.08,3-1.73Zm-12.33.68h.07l3.57,2.06-3,1.75-3.68-2.08,3-1.74Zm-11.82.38h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm35.73.08h.08l3.56,2.06L299,303l-3.68-2.08,3-1.74Zm-59.11.53h.08l3.57,2.06L238,304.58l-3.69-2.07,4.83-2.79Zm10.26.52h.08l3.56,2.06-9.51,5.49-3.69-2.07,9.51-5.49Zm32.34.66.08,0,3.56,2.06-3,1.74-3.68-2.08,3-1.73Zm-12.34.68.08,0,3.56,2-3,1.75-3.68-2.08,3-1.74Zm-11.82.38h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm35.73.08.08,0,3.56,2.05-3,1.75-3.69-2.08,3-1.74Zm-16.51,1.71.08,0,3.56,2.06-3,1.74-3.68-2.08,3-1.73Zm-45.46.47h.08l3.57,2.06-3,1.74L228.37,306l3-1.74Zm33.12.21.08,0,3.56,2.05-3,1.75-3.69-2.08,3-1.73Zm-11.82.38h.08l3.56,2.06-2.75,1.6a.58.58,0,0,0-.31.5.6.6,0,0,0,.33.52l4.68,2.71-3.54,2L245.51,309l7.18-4.15Zm35.73.08.08,0,3.57,2-3,1.75-3.69-2.07,3-1.74ZM272,306.6l.08,0,3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm-45.46.47h.08l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm33.12.21.08,0,3.57,2.06-3,1.74L256.55,309l3-1.73Zm21.76,1.7.08,0,3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-14.36.47a.13.13,0,0,1,.08,0l3.57,2.06-3,1.74L264,311.2l3-1.74Zm-45.45.47.08,0L225.2,312l-3,1.74-3.68-2.07,3-1.74Zm10.52.37h.08l3.56,2.06-3,1.75L229,312l3-1.74Zm44.35,1.54a.14.14,0,0,1,.09,0l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-14.35.47.08,0,3.56,2.06-5.36,3.09-3.68-2.07,5.35-3.09Zm-46.5,1.07.08,0,3.57,2.05-8,4.6L207.58,318l7.95-4.59Zm32.6.51.08,0,3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm23.32.81h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm-50.34,1.9.08,0,3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm22.08.15h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74Zm10.52.37h.08l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm12.8.43h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-60.86,1.53a.14.14,0,0,1,.09,0l3.56,2.05-3,1.75-3.69-2.07,3-1.74Zm10.52.37.08,0,3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm22.08.15h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-11.56.23h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm22.08.14h.08l3.56,2.06-3,1.74-3.69-2.07,3-1.74ZM260.53,321h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-59.76.9.08,0,9.14,5.28L207,329l-9.27-5.29,3-1.74Zm10.51.37a.14.14,0,0,1,.09,0l3.56,2.06-3,1.74L208.23,324l3-1.74Zm10.52.38h.08l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm22.08.14H244l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-11.56.23h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm23.27.83h.08l3.57,2.06-3,1.74-3.69-2.07,3-1.74Zm-38.72,1.65H217l3.56,2.06-3,1.74-3.68-2.07,3-1.74Zm10.51.37h.08L231,328l-3,1.74-3.68-2.07,3-1.74Zm10.52.37H238l3.57,2.06-3,1.74L234.85,328l3-1.74Zm12.75.46h.08l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm-38.72,1.65H212l9.15,5.28-3,1.74-9.27-5.29,3-1.74Zm10.52.37h.07l3.57,2.06-3,1.74-3.68-2.07,3-1.74Zm10.52.37H233l3.57,2.06-3,1.74-3.68-2.07,3-1.74ZM246.11,331h.08l1.55.88-3,1.74-1.66-.9,3-1.73ZM228,332l.08,0,3.56,2-3,1.75L225,333.7l3-1.73Zm13.14,1.89h.08l1.55.88-3,1.74-1.65-.89,3-1.74Zm-18.08,1,.08,0,3.56,2.05-3,1.75L220,336.55l3-1.73Zm13.14,1.89h.09l1.54.88-3,1.74-1.66-.89,3-1.74Zm-4.94,2.85a.14.14,0,0,1,.09,0l1.55.87-3,1.74-1.66-.89,3-1.74Z",
    style: {
      fill: "#E68072"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hand--inject-589",
    d: "M254.46,276.71a63.46,63.46,0,0,0-10.89-11.93c-4.9-3.88-6.91-5.06-15.7-9.1l-12.69,17.63,3.91,1.11c1.65.55,2.53.7,3.18,2.2a41.89,41.89,0,0,1,.81,5.2,40.41,40.41,0,0,0,2,8.51c1.43,4.08,2.31,3.79,4.83,7,2.33,3,3.29,5,4.55,4.81s2.82-2.69,2.12-5.47-3.08-6.76-3.43-7.92c-.3-1-.82-2.86,2.2-2s8.73,7.71,11.5,10.49,4.52,7.07,7.1,8.93,6.41,1.7,5.27-2.41c.38-2.39,1.78-6.53,2.08-10.35S257.35,280.76,254.46,276.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.61,335l-6.39-3.56a7.74,7.74,0,0,0-7.23-.09L393.21,349.7,389,347.26a7.09,7.09,0,0,0-6.45,0L344,369.68c-1.78,1-1.78,2.69,0,3.72l4.07,2.35-45.93,26.51c-2,1.17-2,3.06,0,4.22l6.39,3.69a8.09,8.09,0,0,0,7.3,0l45.92-26.52a7.12,7.12,0,0,0,6.45,0l38.44-22.34c1.73-1,1.77-2.61.14-3.65l31.76-18.34C440.56,338.16,440.59,336.23,438.61,335Z",
    style: {
      fill: "#E68072",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,302.2,432,205.57a8.25,8.25,0,0,0-3.61-7.24,9.18,9.18,0,0,0-8.29.15L298.69,268.6A10.53,10.53,0,0,0,294,276l-8.13,96.63a8.24,8.24,0,0,0,3.6,7.24,9.15,9.15,0,0,0,8.29-.16l121.44-70.11A10.58,10.58,0,0,0,423.9,302.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,302.2,432,205.57a8.25,8.25,0,0,0-3.61-7.24,9.18,9.18,0,0,0-8.29.15L298.69,268.6a9.72,9.72,0,0,0-3.11,3.14l14.89,8.59-.92,92.58,109.66-63.32A10.58,10.58,0,0,0,423.9,302.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9,377.25,302,280.62a10.58,10.58,0,0,1,4.69-7.39l120-69.32c2.36-1.36,3.35-.33,3.12,2.39l-5.89,95.9a10.58,10.58,0,0,1-4.69,7.39L297.77,379.7C295.41,381.07,293.68,380,293.9,377.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,292.17c.37-4.48,3.51-9.75,7-11.78s6,0,5.67,4.43-3.5,9.76-7,11.79S359.57,296.65,359.94,292.17Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.12 329.46 385.07 314.38 380.65 311.83 354.71 326.91 359.12 329.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.11,358.63l-31.6,18.25a3.86,3.86,0,0,1-2,.46,4,4,0,0,1-1.72-.44s0,0,0,0l-13.91-8s0,0-.07-.05a4.07,4.07,0,0,1-1.8-3.22v-.74c0-1.2.82-1.7,1.87-1.09l8.41,4.83,1.87,1.09-.42-2.13-3-40.63,4.41,2.56,26-15.08,13.51,41A3.26,3.26,0,0,1,397.11,358.63Z",
    style: {
      fill: "#37474f"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "346.52 363.6 357.3 357.37 359.49 371.88 346.52 363.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,329.47l-4.41-2.56,3,40.63c.24,1.17-.43,1.65-1.45,1l-8.41-4.83c-1.05-.61-1.87-.11-1.87,1.09v.74a4.07,4.07,0,0,0,1.8,3.22s.05,0,.07.05l13.91,8s0,0,0,0a4,4,0,0,0,1.72.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,164.58c17.15,1.51,19.9,9.2,24.49,22.9,5.49,16.37,14.69,48.34,14.69,48.34l41.92,19.86-12.69,17.63s-28.07-5.55-41.21-10.14c-10.32-3.62-10.87-7-19.38-30.59-6-16.61-9-27-9-27C147,192.62,146.77,164.58,146.77,164.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,163.74c8.93.84,15.36,1.28,21.26,12.72s18.72,59.13,18.72,59.13l5.58,3.26s-5.45-2.43-12.69,2.66S169.1,256,171.42,262.86a20.9,20.9,0,0,1-9.59-7.18c-7.62-11.12-16.73-49.38-16.73-49.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,233.4c2-.06,2.46,1.61,3.69,2.62s1.66.32,3,1.28,2.13,1.85,1.82,2.67l-1.69-.8s-9.26-1.71-15.17,5.34S174,263.17,174,263.17l3.81,1.23a4.9,4.9,0,0,1-4.15.62c-2.37-.72-2.4-1.08-4.92-1.52a6.13,6.13,0,0,1-5-3.95c-.94-2.2-2.46-2.2-3.55-4.8S167.5,231.49,186.16,233.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.82,204c1.3-27.13-6.26-37.59-16-40.26a91.9,91.9,0,0,0-30.27-1.23C101.47,166,84,173.7,73.66,178.14c0,0-2.51,4.58-5.28,23.55-2,13.47-4.24,29.63-7.13,55.22-1.78,15.65-9.44,34.54-.81,38.87,21.51,11.29,85.52,2.27,100.21-22,3.28-8.34-3.62-11.72-3.61-23C157.79,231,162.4,212.53,162.82,204Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.51,114a13.75,13.75,0,0,0,1.73-2.51c.7-1.28,1.88-4.18.59-5.38,2-1,4-2.81,4.07-5.22s-1.77-2.36-3.59-2.51c4.24-1.72,6.45-5.92,7-7.32s.55-2.73.14-3.23c-.59-.72-1.24.1-5,.27A21.21,21.21,0,0,1,152.85,85a41.68,41.68,0,0,0-9.14-4.33,51.57,51.57,0,0,0-10-2.39c-7.2-.94-27.34.79-30.07,14.33-9.73,1.23-11.56,16.8-9,23.48,4.65,12.32,9.22,20.52,11.47,29.35.51-.33,33.64-17.89,41.26-22.88l8.58-5.62A16.68,16.68,0,0,0,159.51,114Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,111c4.32-1.72,8-5.48,8.7-10.08l-2.56-3.16c-7.34,3.56-20.85,2.89-24,3.78s6.67,1.81,12.59,2.14c1.35.19.5.87-1.53,1.23a41.09,41.09,0,0,1-7.21.55c-1.25,0-1.26.91.43,1.49a24,24,0,0,0,5.94.84c-.55,1-4.23,1.49-5.34,1.59-2.16.19-4.29-.4-6.07.21s3.43,1.88,5.36,2.23C111.24,112.63,116.08,112.7,120.4,111Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,136.17c5.6,4.53,9.5.54,9.5.54l-1.3,29.42c7.07,10,24.57,14.39,30.12,19,1.51-3,3.15-11.74,0-18.64l.58-7a36.91,36.91,0,0,0,7.84-.07,19.7,19.7,0,0,0,6.84-2.15c3.39-1.89,5.25-4.12,7.07-8.61,2.76-6.81,3.36-22.13,2.62-27.18,1.09-9.65.72-15.2-1.87-21-4.92-4.72-18.89-5.63-31.84-2.5a16.79,16.79,0,0,1-4.1,9.24,13.4,13.4,0,0,1-5,3.64c-.6,6.2-.92,7.87-2.18,10.56-.71,1.55-2.07,3.87-5.19,2.59-1.46-.6-2.43-4-3.88-6.21-2-3-8.41-4.69-11.83,1.57S93.15,133,97,136.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83,159.41c-6.44-.91-17.85-3.83-21-7.92s-5.38-13.3-5.38-13.3.86,10.28,3.2,14.84,7.86,6.57,11.88,8a69.65,69.65,0,0,0,11,2.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,109.82l-6.55,1.61a3.53,3.53,0,0,1,2.55-4.18A3.28,3.28,0,0,1,135.26,109.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77,110.74l6.51,1.75a3.53,3.53,0,0,0-2.45-4.23A3.29,3.29,0,0,0,151.77,110.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.63,138.33l8.28,3.58a4.73,4.73,0,0,1-6.1,2.39A4.4,4.4,0,0,1,132.63,138.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.81,140.1a4.41,4.41,0,0,1,4.22,4.53,4.5,4.5,0,0,1-2.22-.33,4.33,4.33,0,0,1-2.62-4.16A4.3,4.3,0,0,1,132.81,140.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76,116l-1.27-.18c-4.11-.55-9.5-.86-12.83-.09-4.17,1-5.7,2.15-8,2.08-2.42-.1-3.85-1.4-8.13-2.66-3.4-1-9.19-1.1-13.64-.86-.48,0-1,0-1.39.09l-14.83,4.38c.44.87,1,2,1.31,2.64L120.49,118c.19.28.38.53.51.71a2.65,2.65,0,0,1,.37,1c.35,1.65.4,4.8,1.18,6.57a7.72,7.72,0,0,0,1.57,2.4,5.8,5.8,0,0,0,.84.72,5.25,5.25,0,0,0,.49.33,7.37,7.37,0,0,0,1.49.71l.25.08.4.13.42.11a10.08,10.08,0,0,0,1.34.23l.58.07.72,0c5.62.23,8.15-2.08,9.73-4.5s1.49-5.91,4.08-5.81l.24,0,.23,0c1.88.47,1.41,3.66,2.43,6a9,9,0,0,0,1.65,2.58,5.18,5.18,0,0,0,.41.4l.22.19a2.11,2.11,0,0,0,.23.19l.21.16.23.15.18.12.13.08a8.7,8.7,0,0,0,2.18.88l.2,0a14,14,0,0,0,2.72.35c5.26.16,7.28-2.53,8.27-4.24s1.56-4.82,2.11-6.45a2,2,0,0,1,.54-.84,4.5,4.5,0,0,0,1.37-2.36A1.91,1.91,0,0,0,166.76,116Zm-27.66,8.24a7.41,7.41,0,0,1-2.21,3.37h0a8.73,8.73,0,0,1-6.27,1.74c-3.05-.15-4.74-1.35-5.7-2.72l-.17-.25-.15-.26a1.71,1.71,0,0,1-.13-.23l-.1-.21a1.3,1.3,0,0,1-.08-.17l-.07-.15a2.6,2.6,0,0,0-.1-.25h0a7.63,7.63,0,0,1-.23-.73s0,0,0,0-.08-.29-.11-.43-.11-.5-.14-.71a.59.59,0,0,1,0-.13l0-.13c-.3-1.74-.55-5.15.47-5.88s3.64-1.42,7.79-.91l.44.06q1,.14,1.89.36l.73.19a16.87,16.87,0,0,1,1.82.61l.55.23.6.28.12.07a.88.88,0,0,1,.21.12,3.64,3.64,0,0,1,1.19.94C140.14,120.11,139.72,122.34,139.1,124.24Zm24.45.15c-.43,1.33-1.35,4.21-4.37,5.38a8.27,8.27,0,0,1-3.16.49c-3.32-.06-5.1-1.36-6.06-2.81a0,0,0,0,0,0,0l-.1-.17-.12-.18a.47.47,0,0,0,0-.1c-.05-.09-.1-.19-.14-.28s-.1-.22-.14-.33a1,1,0,0,1-.07-.15l0-.09s0-.09-.05-.13l0-.11a6.65,6.65,0,0,1-.3-1.3c-.29-1.93-.34-4.17.53-5.2s4-2.08,7-2.3c.69,0,1.34-.07,1.93-.06h.48l.66,0,.24,0,.31,0,.52.07c.34.06.66.12.95.19l.23.06.06,0,.15,0,.22.07.28.09.44.18.08,0a3.78,3.78,0,0,1,1,.62C164.85,119.31,164.09,122.68,163.55,124.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,121.41a2.76,2.76,0,1,0,2.92-2.6A2.78,2.78,0,0,0,130.16,121.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,122.23a2.76,2.76,0,1,0,2.91-2.6A2.75,2.75,0,0,0,151,122.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.63,131.46l-.17,0L142,135.43l-.64-10.87c.75-2,1.2-3.84,3.1-3.76a.9.9,0,0,1,.24,0l.24,0,0,0,1.43,2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,191a12.23,12.23,0,0,0,2-6.4l-4.1-3.87-.82,5.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.32 186.34 121.46 178.14 111.78 183.97 128.59 193.65 132.32 186.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.63,155.39l-.17,4c0,2.31,2.15,6.88,12.14,14.09,4.57,3.3,10.11,4.79,12.94,6.73a15.21,15.21,0,0,1,4.74,4.85s-3.18-2.39-9.06.79c-4.79,2.59-10.76,6.63-13.12,6.08s-7.45-4.3-12.34-12.13a66.88,66.88,0,0,1-5.59-10.56S97.7,166,100,162.73C102.86,158.59,103.34,155.39,105.63,155.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.28,185.09c5.65-5.68,8.31,2.63,9.59,1.37,1-.94-1-19-9-27l-.58,7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,199.37c.21,8.23-.53,27.66-4,54.75-.86,6.64,7.09,21.38,9.4,21.39s8.14-12.13,9.69-19.41c1.38-17.93-5.8-47-9.29-57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,199.91c-.08-.28-.17-.56-.26-.81l-5.76.27,0,2.41A9.84,9.84,0,0,0,138.46,199.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,186.34a24.14,24.14,0,0,1,5.42,0,13,13,0,0,1,2.92,4.58s-.35,5-2.46,8.14a6.88,6.88,0,0,1-5.76.27s-3.1-2.47-3.85-5.72C128.58,190.89,131,187.06,132.32,186.34Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.39,258.09c3.14-22.88,5.36-30.47,8.92-46.44,5.12-22.93,7.38-25.73,21.62-32.83,9.88,5.8,15.51,23.92,8.85,49.11L74.62,263.5s8.18,11.28,17.07,21.09c7.5,8.29,10.43,14.06,20.61,17.43s14.45,5,19.41,8.43c2.63,1.85,8.64,6.13,10.66,7.73s5.22,6.5,8.39,10c3,3.52-1.76,4.18-4.33,2.82-3.34-1.77-5.22-3.78-7.38-5.65s-4.26-2.73-6.49-4.13a42.45,42.45,0,0,1-.18,8.51c-.3,1.5-.34,3.39-1.87,4.22a11.64,11.64,0,0,1-3.41.65,2.3,2.3,0,0,1-.92,1.32,3.84,3.84,0,0,1-2.81.15,12.06,12.06,0,0,1-1.47-.54,2.81,2.81,0,0,1-2.13,1.81,12.19,12.19,0,0,1-6.44-1.09c-.29-.19-2.41-1.95-3-2.46-.9-.74-1.75-1.22-2-2s1.47-2.39,2.73-2.33a12.8,12.8,0,0,1,4,1.1,14.07,14.07,0,0,1-.47-3.75c-.75-2-10-1.06-16.86-3.74-5.18-2-8.16-7.74-10.2-9.51-12.62-11-23.53-17.68-37.57-29.89C38.4,273.71,41.86,269.28,43.39,258.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,322c-.41-2.19-1.18-4.87-2.61-5.75a18.66,18.66,0,0,1,1.32,5C133,321.5,133.42,321.74,133.85,322Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,334.61a16.93,16.93,0,0,0,1-4.39,39.89,39.89,0,0,0,.33-4.5,19.37,19.37,0,0,0-.32-4.54,8.16,8.16,0,0,0-1.93-4.08,6.31,6.31,0,0,1,.85,2,13.18,13.18,0,0,1,.42,2.15,30.78,30.78,0,0,1,.12,4.41c0,1.49-.08,3-.13,4.46A36.93,36.93,0,0,1,127.1,334.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,335.54a21.54,21.54,0,0,0,.89-4.35,36.42,36.42,0,0,0,.23-4.43,29.92,29.92,0,0,0-.33-4.43,8.54,8.54,0,0,0-1.46-4.18,5.69,5.69,0,0,1,.59,2.08c.11.72.17,1.44.21,2.17.08,1.45.12,2.91.12,4.37C122.17,329.69,122.15,332.6,121.9,335.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,329.5a7.65,7.65,0,0,1,1.75.62c.55.26.9.63,1.58,1l-.2-.53a1.84,1.84,0,0,0-.06.89,2.4,2.4,0,0,0,.27.75,2.61,2.61,0,0,0,1.06,1.05,6.88,6.88,0,0,1-.51-1.27,4.2,4.2,0,0,1-.06-.6,1.93,1.93,0,0,1,.08-.5l.11-.32-.31-.21a5.58,5.58,0,0,0-1.62-.71A3.79,3.79,0,0,0,111,329.5Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,178.14c-11.25,4.36-16.4,7.3-21.13,25s-7.36,35.12-9.68,48.47-4.78,19.64,2.61,27.7c5-13.92,27.28-17,31.21-13l-1.32-3.4s8.51-35,10.2-43.14S89.38,184.81,73.66,178.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,258.86c1.84,1.63-.13,2.75.59,4.18a35.4,35.4,0,0,0,2,3,2.28,2.28,0,0,1-.41,3.05l-1.19-1.48a23.94,23.94,0,0,0-16.51,1c-13.2,6.15-12.57,13.86-12.57,13.86l3,2.62s-3,1-4.85-.6-1-2.38-3.17-3.79a6.14,6.14,0,0,1-3-5.63c0-2.39-1.21-3-1.3-5.82C39.14,263.42,61.57,247.7,76.74,258.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.82,349.5l40.93,23.65,6.46,1.31a.2.2,0,0,0,.22-.29l-2-3.71-40.94-23.65C193.19,346.08,188.82,348.93,189.82,349.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194,343.16a.62.62,0,0,1,.19.07l-.37-.21-.06,0h0l-.07,0h0l-.06,0-.1,0h-.12a1.49,1.49,0,0,0-.77.24,3.81,3.81,0,0,0-1.73,3,1.91,1.91,0,0,0,0,.43s0,.05,0,.07,0,0,0,.05l0,.08a1.1,1.1,0,0,0,.15.26.1.1,0,0,0,0,.05h0l0,.05.08.06.06,0,0,0,.42.24a.9.9,0,0,1-.19-.15,1.45,1.45,0,0,0,1-.21,3.82,3.82,0,0,0,1.73-3A1.39,1.39,0,0,0,194,343.16Zm-2.56,4.13,0,0Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.41,365.87,231,370.12l-.41-.24L191.76,347.5a.9.9,0,0,1-.19-.15,1.39,1.39,0,0,1-.32-1,3.83,3.83,0,0,1,1.74-3,1.54,1.54,0,0,1,.77-.23.78.78,0,0,1,.22,0,.62.62,0,0,1,.19.07h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,366c1-.55,1.73-.1,1.73,1a3.84,3.84,0,0,1-1.73,3c-1,.55-1.73.1-1.73-1A3.84,3.84,0,0,1,232.18,366Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.91,368.57l0-.05-2.21-2.43h0l0,0,0,0,0,0h0a1.11,1.11,0,0,0-1.38,0,3.84,3.84,0,0,0-1.73,3,1.13,1.13,0,0,0,.67,1.19h0a.5.5,0,0,0,.13,0h0l3.21.7a.82.82,0,0,0,.56-.12,2.2,2.2,0,0,0,1-1.72A.85.85,0,0,0,235.91,368.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,351h0l-.06,0a.44.44,0,0,0-.4.06,1.35,1.35,0,0,0-.62,1.07.46.46,0,0,0,.15.37h0l.07,0,29.45,17,1.73-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.6,368.08l2.45,1.41,1.73-1-3.31-1.91A4,4,0,0,0,230.6,368.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.78,369.72h0l-2-2.2a.15.15,0,0,0-.05-.06.77.77,0,0,0-1,0,2.69,2.69,0,0,0-1.22,2.12c0,.45.18.75.46.84h0l.08,0,2.94.64h0a.45.45,0,0,0,.32-.07,1.23,1.23,0,0,0,.56-1A.44.44,0,0,0,236.78,369.72Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.78,369.72h0l-2-2.2a.15.15,0,0,0-.05-.06.77.77,0,0,0-1,0,2.69,2.69,0,0,0-1.22,2.12c0,.45.18.75.46.84h0l.08,0,2.94.64h0a.45.45,0,0,0,.32-.07,1.23,1.23,0,0,0,.56-1A.44.44,0,0,0,236.78,369.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.89,370a1.23,1.23,0,0,1-.56,1,.43.43,0,0,1-.31.07h0l-1.48-.33c-.24-.05-.39-.27-.39-.62a2,2,0,0,1,.89-1.55.56.56,0,0,1,.71,0l0,0,1,1.09h0A.44.44,0,0,1,236.89,370Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,369.72c.31-.18.56,0,.56.32a1.23,1.23,0,0,1-.56,1c-.31.18-.56,0-.56-.32A1.23,1.23,0,0,1,236.33,369.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.91,347.21a.45.45,0,0,0-.43,0,1.38,1.38,0,0,0-.62,1.07.42.42,0,0,0,.19.4h0l6.48,3.74a.46.46,0,0,1-.15-.37A1.35,1.35,0,0,1,204,351a.44.44,0,0,1,.4-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.09,347.61a1.34,1.34,0,0,1-.61,1.06.4.4,0,0,1-.43,0,.4.4,0,0,1-.19-.39,1.38,1.38,0,0,1,.62-1.07.45.45,0,0,1,.43,0A.44.44,0,0,1,198.09,347.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.72,345h-.05l-2.55-1.48-.06,0h0a1.11,1.11,0,0,0-1,.13,3.43,3.43,0,0,0-1.56,2.7,1.1,1.1,0,0,0,.46,1h0l2.58,1.49h0a1.09,1.09,0,0,0,1.08-.12,3.4,3.4,0,0,0,1.56-2.7A1.13,1.13,0,0,0,196.72,345Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.72,345h-.05l-2.55-1.48-.06,0h0a1.11,1.11,0,0,0-1,.13,3.43,3.43,0,0,0-1.56,2.7,1.1,1.1,0,0,0,.46,1h0l2.58,1.49h0a1.09,1.09,0,0,0,1.08-.12,3.4,3.4,0,0,0,1.56-2.7A1.13,1.13,0,0,0,196.72,345Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,345.07c.87-.5,1.56-.09,1.56.9a3.4,3.4,0,0,1-1.56,2.7c-.86.5-1.56.1-1.56-.9A3.46,3.46,0,0,1,195.58,345.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6,370.65h0l-1.06-.63h0a.23.23,0,0,0-.21,0,.65.65,0,0,0-.28.5c0,.09,0,.16.08.18h0l1.05.64h0a.46.46,0,0,0,.2,0,.41.41,0,0,0,.41-.4A.43.43,0,0,0,237.6,370.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.66,370.7h0l-.06-.05h0a.23.23,0,0,0-.19,0,.65.65,0,0,0-.28.5.19.19,0,0,0,.08.18h0a.27.27,0,0,0,.13,0,.41.41,0,0,0,.41-.4A.4.4,0,0,0,237.66,370.7Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Invoices--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-589",
    d: "M106.61,401.87,183.08,446a4.72,4.72,0,0,0,4.3,0l56.28-32.49a1.31,1.31,0,0,0,0-2.49l-76.47-44.15a4.81,4.81,0,0,0-4.31,0l-56.27,32.49A1.31,1.31,0,0,0,106.61,401.87Z",
    style: {
      fill: "#E68072",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.61,397.89,183.08,442a4.79,4.79,0,0,0,4.3,0l56.28-32.49a1.31,1.31,0,0,0,0-2.49l-76.47-44.15a4.75,4.75,0,0,0-4.31,0L106.61,395.4A1.31,1.31,0,0,0,106.61,397.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,362.91l-53.44,30.85,73.64,42.52a4.79,4.79,0,0,0,4.3,0l53.44-30.86-73.63-42.51A4.75,4.75,0,0,0,162.88,362.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.61,390.11l76.47,44.15a4.72,4.72,0,0,0,4.3,0l56.28-32.49a1.31,1.31,0,0,0,0-2.48l-76.47-44.15a4.75,4.75,0,0,0-4.31,0l-56.27,32.49A1.31,1.31,0,0,0,106.61,390.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-589"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "207.98 420.74 195.33 428.03 187.64 423.59 226.14 401.37 233.84 405.81 207.98 420.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.3,397.61l-12.45,7.19a1.1,1.1,0,0,1-1,0c-.26-.15-.25-.41,0-.57l12.44-7.19a1.1,1.1,0,0,1,1,0C226.59,397.19,226.58,397.45,226.3,397.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.37,396.5l-12.45,7.18a1.05,1.05,0,0,1-1,0c-.27-.15-.25-.41,0-.57l12.45-7.19a1.11,1.11,0,0,1,1,0C224.67,396.08,224.65,396.33,224.37,396.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.45,395.39,210,402.57a1.08,1.08,0,0,1-1,0c-.27-.15-.26-.41,0-.57l12.44-7.19a1.13,1.13,0,0,1,1,0C222.74,395,222.73,395.22,222.45,395.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,394.28l-12.45,7.18a1.11,1.11,0,0,1-1,0c-.27-.15-.25-.41,0-.57l12.45-7.19a1.11,1.11,0,0,1,1,0C220.82,393.85,220.8,394.11,220.52,394.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,410.79,169.85,418a1.1,1.1,0,0,1-1,0c-.26-.15-.25-.41,0-.57l12.44-7.19a1.1,1.1,0,0,1,1,0C182.59,410.37,182.58,410.63,182.3,410.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,409.68l-12.45,7.18a1.05,1.05,0,0,1-1,0c-.27-.15-.25-.41,0-.57l12.45-7.19a1.11,1.11,0,0,1,1,0C180.67,409.26,180.65,409.51,180.37,409.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,408.57,166,415.75a1.07,1.07,0,0,1-1,0c-.26-.15-.25-.41,0-.57L177.48,408a1.13,1.13,0,0,1,1,0C178.74,408.15,178.73,408.4,178.45,408.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.52,407.46l-12.45,7.18a1.08,1.08,0,0,1-1,0c-.27-.15-.25-.41,0-.57l12.45-7.19a1.11,1.11,0,0,1,1,0C176.82,407,176.8,407.29,176.52,407.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,363.16l-47.09,27.19a1.11,1.11,0,0,1-1,0c-.27-.16-.26-.41,0-.58l47.09-27.18a1.05,1.05,0,0,1,1,0C166.93,362.74,166.91,363,166.63,363.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.71,362.05l-47.09,27.19a1.13,1.13,0,0,1-1,0c-.26-.16-.25-.41,0-.58l47.09-27.18a1.07,1.07,0,0,1,1,0C165,361.63,165,361.89,164.71,362.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,415.09,180.62,424a1.1,1.1,0,0,1-1,0c-.26-.15-.25-.41,0-.57l15.4-8.89a1.07,1.07,0,0,1,1,0C196.31,414.67,196.3,414.93,196,415.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.09,414l-15.4,8.89a1.11,1.11,0,0,1-1,0c-.27-.15-.25-.41,0-.58l15.4-8.88a1.05,1.05,0,0,1,1,0C194.39,413.56,194.37,413.82,194.09,414Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,412.87l-15.39,8.89a1.13,1.13,0,0,1-1,0c-.26-.16-.25-.41,0-.58l15.39-8.89a1.1,1.1,0,0,1,1,0C192.46,412.45,192.45,412.71,192.16,412.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.24,411.76l-15.4,8.89a1.11,1.11,0,0,1-1,0c-.27-.16-.25-.41,0-.58l15.4-8.89a1.11,1.11,0,0,1,1,0C190.54,411.34,190.52,411.59,190.24,411.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.82,387.69a.42.42,0,0,1,.21,0,.52.52,0,0,1,.22.07l5.88,3.39c.07,0,.11.08.12.13a.11.11,0,0,1-.06.12l-.89.52a.32.32,0,0,1-.2,0,.52.52,0,0,1-.23-.07L208,388.46a.25.25,0,0,1-.12-.13.11.11,0,0,1,.06-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,390.66a.54.54,0,0,1,.27-.06l.22,0,4.67.89-3.08-1.77a.22.22,0,0,1-.11-.13.09.09,0,0,1,.05-.12l.9-.52a.38.38,0,0,1,.2,0,.62.62,0,0,1,.23.07l5.87,3.39c.07,0,.11.08.12.13a.11.11,0,0,1-.06.12l-.71.41a.38.38,0,0,1-.26.06l-.22,0-4.68-.89,3.08,1.77a.29.29,0,0,1,.12.13.11.11,0,0,1-.06.12l-.89.52a.35.35,0,0,1-.21,0,.62.62,0,0,1-.23-.07L203,391.32c-.07,0-.11-.08-.12-.13a.11.11,0,0,1,.06-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,392.56a.91.91,0,0,1,.73,0l7.07,2.48.1,0,0,0a.17.17,0,0,1,.1.11.08.08,0,0,1-.05.09l-.86.5a.54.54,0,0,1-.27.07,1,1,0,0,1-.22-.05l-4.95-1.76,3,2.86a.2.2,0,0,1,.08.12c0,.06,0,.11-.12.16l-.86.5a.26.26,0,0,1-.16,0,.41.41,0,0,1-.19-.05l0,0-.06-.06-4.3-4.09c-.18-.18-.18-.31,0-.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,396.59a3.81,3.81,0,0,1,.79.65,1.54,1.54,0,0,1,.37.7,1,1,0,0,1-.13.68,1.91,1.91,0,0,1-.7.63,3.59,3.59,0,0,1-1.08.4,5.22,5.22,0,0,1-1.19.07,4.88,4.88,0,0,1-1.19-.21,5.94,5.94,0,0,1-1.13-.46l-.83-.46-.79-.47a3.56,3.56,0,0,1-.79-.65,1.5,1.5,0,0,1-.37-.7.93.93,0,0,1,.13-.68,1.86,1.86,0,0,1,.69-.63,3.75,3.75,0,0,1,1.09-.4,4.6,4.6,0,0,1,1.18-.07,5,5,0,0,1,1.2.21,6.22,6.22,0,0,1,1.13.46l.81.45Zm-4.57.82.35.22.4.24.41.23.37.2a3,3,0,0,0,.49.2,2.11,2.11,0,0,0,.49.09,1.6,1.6,0,0,0,.49,0,1.42,1.42,0,0,0,.45-.16.79.79,0,0,0,.28-.26.36.36,0,0,0,0-.28.65.65,0,0,0-.16-.29,1.72,1.72,0,0,0-.35-.28l-.33-.22-.41-.23-.41-.24-.38-.2a3,3,0,0,0-1-.3,1.55,1.55,0,0,0-.93.19q-.42.26-.33.54A1.24,1.24,0,0,0,196.83,397.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,397.31a.34.34,0,0,1,.21,0,.52.52,0,0,1,.22.07l5.88,3.39c.07,0,.11.08.12.13a.11.11,0,0,1-.06.12l-.89.52a.4.4,0,0,1-.2,0,.52.52,0,0,1-.23-.07l-5.88-3.39a.25.25,0,0,1-.12-.13.11.11,0,0,1,.06-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,401.4l-.32-.19c-.13-.09-.28-.17-.43-.26l-.44-.25-.34-.18a3.76,3.76,0,0,0-.46-.2,2,2,0,0,0-.49-.1,1.61,1.61,0,0,0-.49,0,1.43,1.43,0,0,0-.47.18.7.7,0,0,0-.31.26.39.39,0,0,0-.07.24.45.45,0,0,0,.08.22l.16.18a.46.46,0,0,1,.13.16s0,.08-.1.13l-.89.52a.27.27,0,0,1-.16,0,.41.41,0,0,1-.19-.05,2.52,2.52,0,0,1-.7-.61,1.15,1.15,0,0,1-.26-.67,1.12,1.12,0,0,1,.19-.66,1.81,1.81,0,0,1,.66-.58,3.37,3.37,0,0,1,1.07-.4,4.74,4.74,0,0,1,1.19-.07,5,5,0,0,1,1.21.21,6.55,6.55,0,0,1,1.12.45c.26.14.53.29.81.46s.56.32.81.48a3.43,3.43,0,0,1,.78.64,1.45,1.45,0,0,1,.37.7,1,1,0,0,1-.12.69,1.85,1.85,0,0,1-.69.62,3.58,3.58,0,0,1-1,.38,5.54,5.54,0,0,1-1.15.11,5.67,5.67,0,0,1-1.16-.15,4.41,4.41,0,0,1-1.05-.41.17.17,0,0,1-.09-.1.08.08,0,0,1,0-.1l.9-.51a.31.31,0,0,1,.21-.06l.28.07.32.1a2.22,2.22,0,0,0,.38,0,1.57,1.57,0,0,0,.42,0,1.52,1.52,0,0,0,.46-.17.75.75,0,0,0,.3-.28.45.45,0,0,0,0-.28.7.7,0,0,0-.19-.28A3.37,3.37,0,0,0,193,401.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,404.07a.4.4,0,0,1-.2,0A.56.56,0,0,1,183,404l-1-.56a.2.2,0,0,1-.11-.13.08.08,0,0,1,0-.11l3.24-1.87a.3.3,0,0,1,.2,0,.6.6,0,0,1,.23.06l5.87,3.4c.07,0,.11.08.12.13a.09.09,0,0,1-.06.11l-3.17,1.84a.34.34,0,0,1-.21,0,.51.51,0,0,1-.22-.06l-1-.56c-.07,0-.11-.08-.12-.13a.11.11,0,0,1,.06-.12l2.1-1.21-1-.57-1.95,1.13a.32.32,0,0,1-.2,0,.52.52,0,0,1-.23-.07l-1-.56a.2.2,0,0,1-.11-.13s0-.08,0-.11l2-1.13-1-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.6 385.64 158.48 413.43 157.52 412.87 205.64 385.09 206.6 385.64",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.6 385.64 158.48 413.43 157.52 412.87 205.64 385.09 206.6 385.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.58 371.2 133.46 398.98 132.5 398.42 180.62 370.64 181.58 371.2",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.58 371.2 133.46 398.98 132.5 398.42 180.62 370.64 181.58 371.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.71 383.98 186.39 393.98 184.47 392.87 201.79 382.87 203.71 383.98",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.54 396.2 174.84 400.65 172.92 399.54 180.62 395.09 182.54 396.2",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.92 401.76 165.22 406.2 163.29 405.09 170.99 400.65 172.92 401.76",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.29 407.31 155.6 411.76 153.67 410.65 161.37 406.2 163.29 407.31",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.94 380.64 149.82 408.43 145.97 406.2 194.09 378.42 197.94 380.64",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.24 376.2 142.12 403.98 138.27 401.76 186.39 373.98 190.24 376.2",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.63,382.69a1.62,1.62,0,0,1,.62,0c.29.06.39.18.22.28L185,390.75a1.42,1.42,0,0,1-.84.07c-.3-.05-.4-.18-.23-.28l13.47-7.78A1,1,0,0,1,197.63,382.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,395.39a1.13,1.13,0,0,1,.41,0c.2,0,.27.12.16.19l-5.78,3.33a.91.91,0,0,1-.56,0c-.2,0-.26-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.91,394.6a.94.94,0,0,1,.41,0c.2,0,.26.12.15.18l-5.77,3.34a1.14,1.14,0,0,1-.57.05c-.19,0-.26-.13-.15-.19l5.78-3.33A.33.33,0,0,1,175.91,394.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.94,400.53a.94.94,0,0,1,.41,0c.2,0,.26.12.15.19l-5.77,3.33a1,1,0,0,1-.56.05c-.2,0-.27-.12-.16-.19l5.78-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.32,406.08a1.41,1.41,0,0,1,.41,0c.19,0,.26.13.15.19l-5.78,3.33a.91.91,0,0,1-.56,0c-.2,0-.26-.12-.15-.18l5.78-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,380.47a1.62,1.62,0,0,1,.62,0c.29,0,.39.18.22.28L185,386.3a1.41,1.41,0,0,1-.84.08c-.3-.06-.4-.18-.23-.28l9.63-5.56A.57.57,0,0,1,193.78,380.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,393.17a.94.94,0,0,1,.41,0c.19,0,.26.12.15.18l-5.78,3.34a1,1,0,0,1-.56.05c-.2,0-.26-.12-.15-.19l5.77-3.33A.5.5,0,0,1,173.44,393.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.06,392.37a1.41,1.41,0,0,1,.41,0c.2,0,.26.12.15.19l-5.77,3.33a.93.93,0,0,1-.56.05c-.2,0-.27-.12-.15-.18l5.77-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09,398.31a.94.94,0,0,1,.41,0c.2,0,.26.12.15.18l-5.77,3.34a1.11,1.11,0,0,1-.56.05c-.2,0-.27-.13-.15-.19l5.77-3.33A.33.33,0,0,1,163.09,398.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,403.86a1.41,1.41,0,0,1,.41,0c.19,0,.26.12.15.19l-5.78,3.33a.91.91,0,0,1-.56.05c-.19,0-.26-.12-.15-.18l5.78-3.34A.44.44,0,0,1,153.47,403.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,378.25a1.84,1.84,0,0,1,.62,0c.29.06.39.19.22.29l-15.4,8.88a1.4,1.4,0,0,1-.84.08c-.29-.06-.39-.18-.22-.28l15.4-8.89A.57.57,0,0,1,189.93,378.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,390.94a1.41,1.41,0,0,1,.41,0c.19,0,.26.13.15.19l-5.78,3.33a.91.91,0,0,1-.56.05c-.2,0-.26-.12-.15-.18l5.78-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,390.15a1.13,1.13,0,0,1,.41,0c.2,0,.26.12.15.19L163,393.67a.93.93,0,0,1-.56.05c-.2,0-.27-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,396.08a1.41,1.41,0,0,1,.41,0c.2,0,.26.12.15.19L154,399.6a.93.93,0,0,1-.56,0c-.2,0-.27-.12-.15-.18l5.77-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,401.64a1.13,1.13,0,0,1,.41,0c.19,0,.26.12.15.19l-5.78,3.33a.91.91,0,0,1-.56,0c-.19,0-.26-.12-.15-.19l5.78-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,376a1.84,1.84,0,0,1,.62,0c.29.06.39.18.22.28l-7.7,4.45a1.41,1.41,0,0,1-.84.07c-.29-.05-.39-.18-.22-.28l7.7-4.44A.79.79,0,0,1,186.08,376Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,388.72a1.41,1.41,0,0,1,.41,0c.19,0,.26.12.15.19l-5.78,3.33a.91.91,0,0,1-.56.05c-.19,0-.26-.12-.15-.18l5.78-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,387.93a.94.94,0,0,1,.41,0c.2,0,.26.12.15.18l-5.77,3.34a1,1,0,0,1-.56.05c-.2,0-.27-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.39,393.86a1.41,1.41,0,0,1,.41,0c.2,0,.26.12.15.19l-5.77,3.33a.93.93,0,0,1-.56.05c-.2,0-.27-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,399.42a.94.94,0,0,1,.41,0c.19,0,.26.12.15.18l-5.78,3.34a1,1,0,0,1-.56.05c-.19,0-.26-.12-.15-.19l5.78-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,373.8a1.62,1.62,0,0,1,.62,0c.29.06.39.18.22.28l-13.47,7.78a1.42,1.42,0,0,1-.84.07c-.29-.05-.39-.18-.22-.28L182,373.88A.56.56,0,0,1,182.23,373.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,386.5a1.13,1.13,0,0,1,.41,0c.19,0,.26.12.15.19L156.67,390a.91.91,0,0,1-.56.05c-.19,0-.26-.12-.15-.19l5.78-3.33A.44.44,0,0,1,161.89,386.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,385.71a.94.94,0,0,1,.41,0c.2,0,.27.12.15.18l-5.77,3.34a1.1,1.1,0,0,1-.56,0c-.2,0-.27-.13-.15-.19l5.77-3.33A.33.33,0,0,1,160.51,385.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,391.64a.94.94,0,0,1,.41,0c.2,0,.27.12.15.19l-5.77,3.33a1,1,0,0,1-.56,0c-.2,0-.27-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,397.19a1.41,1.41,0,0,1,.41,0c.2,0,.26.13.15.19l-5.78,3.34a1.08,1.08,0,0,1-.56,0c-.19,0-.26-.13-.15-.19l5.78-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,388.3a1.14,1.14,0,0,1,.41,0c.19,0,.26.12.15.18l-5.78,3.34a1.08,1.08,0,0,1-.56.05c-.19,0-.26-.13-.15-.19l5.78-3.33A.42.42,0,0,1,145.77,388.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,393.86a1.41,1.41,0,0,1,.41,0c.2,0,.27.12.15.19l-5.77,3.33a.91.91,0,0,1-.56.05c-.2,0-.26-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,387.19a1.41,1.41,0,0,1,.41,0c.2,0,.27.13.15.19l-5.77,3.33a.92.92,0,0,1-.56.05c-.2,0-.27-.12-.15-.18l5.77-3.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22,392.75a1.13,1.13,0,0,1,.41,0c.2,0,.26.12.15.19L129,396.27a.93.93,0,0,1-.56.05c-.2,0-.27-.12-.15-.19l5.77-3.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.73 395.09 157.52 377.31 151.75 373.98 120.95 391.76 126.73 395.09",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.39,379.86a.16.16,0,0,1-.1,0,.2.2,0,0,1-.11,0l-.47-.27s-.05,0-.05-.06,0,0,0-.06l.57-.33-2.25-1.3s0,0,0-.07a0,0,0,0,1,0-.05l.44-.25.09,0,.11,0,2.25,1.3.58-.34a.16.16,0,0,1,.1,0,.2.2,0,0,1,.11,0l.46.27s.06,0,.06.06,0,0,0,.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,379.35a1.37,1.37,0,0,1,.38.32.68.68,0,0,1,.18.33.49.49,0,0,1-.06.33.79.79,0,0,1-.34.3,1.55,1.55,0,0,1-.52.19,2.19,2.19,0,0,1-.57,0,2.94,2.94,0,0,1-.58-.1,3.21,3.21,0,0,1-.54-.22l-.4-.23-.38-.22a1.56,1.56,0,0,1-.38-.32.68.68,0,0,1-.18-.33.48.48,0,0,1,.06-.33.85.85,0,0,1,.34-.3,1.56,1.56,0,0,1,.52-.2,2.14,2.14,0,0,1,.57,0,2.35,2.35,0,0,1,.58.1,3.21,3.21,0,0,1,.54.22l.39.22Zm-2.2.4.17.1.19.12.2.11.18.09.23.1.24.05h.23a.83.83,0,0,0,.22-.08.36.36,0,0,0,.14-.13.15.15,0,0,0,0-.13.29.29,0,0,0-.08-.14.61.61,0,0,0-.17-.14l-.16-.1-.19-.12-.2-.11-.19-.09a1.36,1.36,0,0,0-.47-.15.68.68,0,0,0-.45.09c-.14.08-.19.17-.16.26A.58.58,0,0,0,146.77,379.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,382.37a.16.16,0,0,1-.1,0,.2.2,0,0,1-.11,0l-.47-.27s0,0,0-.06a0,0,0,0,1,0-.06l.58-.34-2.25-1.29s-.05,0-.05-.07a0,0,0,0,1,0,0l.43-.25a.16.16,0,0,1,.1,0,.35.35,0,0,1,.11,0l2.25,1.3.58-.33.1,0,.11,0,.46.26s.06,0,.06.07,0,0,0,.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65,383.17a.32.32,0,0,1-.14,0l-.15,0L140.88,382l-.08,0a.07.07,0,0,1,0-.06s0,0,0,0l.41-.24a.17.17,0,0,1,.13,0l.11,0,.46.16.87-.51-.27-.26,0-.06a.08.08,0,0,1,.06-.08l.41-.24a.11.11,0,0,1,.08,0l.09,0s0,0,0,.05l2.05,2a.22.22,0,0,1,.05.08s0,.06-.05.09Zm-1.38-1.42-.53.31,1.32.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.53,383.39l-.1,0-.11,0-.46-.26s-.06,0-.06-.07,0,0,0-.05l1.52-.88a.15.15,0,0,1,.1,0,.23.23,0,0,1,.11,0l2.83,1.64.06.06s0,.05,0,.06l-.43.25a.16.16,0,0,1-.1,0,.2.2,0,0,1-.11,0l-2.25-1.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,388.78a1.43,1.43,0,0,1-.41.09,1.79,1.79,0,0,1-.4,0,2,2,0,0,1-.35-.06,1.49,1.49,0,0,1-.28-.11.12.12,0,0,1-.06-.06.07.07,0,0,1,0-.06l.22-.13.12,0h.13a.92.92,0,0,0,.34,0,.83.83,0,0,0,.37-.13.4.4,0,0,0,.14-.11.19.19,0,0,0,.07-.11.17.17,0,0,0,0-.12.44.44,0,0,0-.12-.11.8.8,0,0,0-.2-.07h-.23l-.29.08-.4.12-.47.12a1.91,1.91,0,0,1-.41,0,1.61,1.61,0,0,1-.37-.07,2,2,0,0,1-.36-.17,1,1,0,0,1-.27-.21.5.5,0,0,1-.12-.24.34.34,0,0,1,0-.24.63.63,0,0,1,.2-.24l-.3-.18a.09.09,0,0,1-.06-.06s0,0,0-.05l.26-.16a.16.16,0,0,1,.1,0,.2.2,0,0,1,.11,0l.3.17a2.36,2.36,0,0,1,.38-.1,2.83,2.83,0,0,1,.41,0,1.9,1.9,0,0,1,.4,0,1.66,1.66,0,0,1,.37.14.17.17,0,0,1,.06.06.06.06,0,0,1,0,.06l-.23.13a.28.28,0,0,1-.12,0l-.12,0-.17,0a.61.61,0,0,0-.19,0,.93.93,0,0,0-.22,0,.89.89,0,0,0-.23.1.83.83,0,0,0-.17.12.35.35,0,0,0-.1.13.17.17,0,0,0,0,.14.31.31,0,0,0,.13.12.47.47,0,0,0,.2.06.74.74,0,0,0,.25,0l.31-.08.42-.13.42-.09a1.62,1.62,0,0,1,.38,0,1.72,1.72,0,0,1,.37.07,1.79,1.79,0,0,1,.37.18.75.75,0,0,1,.27.21.59.59,0,0,1,.13.23.37.37,0,0,1,0,.23.62.62,0,0,1-.15.22l.29.17a.1.1,0,0,1,.06.07s0,0,0,.05l-.26.16h-.1a.2.2,0,0,1-.11,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.77,390.1a1.51,1.51,0,0,1-.41.09,1.8,1.8,0,0,1-.4,0,1.93,1.93,0,0,1-.36-.06,1.16,1.16,0,0,1-.27-.11.07.07,0,0,1-.06-.06s0,0,0-.06l.23-.13a.23.23,0,0,1,.11,0h.13a.94.94,0,0,0,.34,0,.86.86,0,0,0,.38-.13l.14-.1a.34.34,0,0,0,.06-.12.17.17,0,0,0,0-.12.25.25,0,0,0-.12-.1.5.5,0,0,0-.2-.08.56.56,0,0,0-.22,0,1.28,1.28,0,0,0-.3.07l-.4.12-.46.12a1.94,1.94,0,0,1-.41,0,1.43,1.43,0,0,1-.37-.07,2,2,0,0,1-.36-.17.75.75,0,0,1-.27-.21.52.52,0,0,1-.13-.24.4.4,0,0,1,0-.24.85.85,0,0,1,.2-.24l-.3-.17a.13.13,0,0,1-.06-.07.05.05,0,0,1,0-.05l.27-.16a.13.13,0,0,1,.09,0,.24.24,0,0,1,.12,0l.29.17a2.36,2.36,0,0,1,.38-.1,2.83,2.83,0,0,1,.41,0,1.83,1.83,0,0,1,.4.05,1.66,1.66,0,0,1,.37.14s.06,0,.06.06a.06.06,0,0,1,0,.06l-.23.13a.3.3,0,0,1-.11,0l-.13,0-.17,0a.59.59,0,0,0-.19,0,.78.78,0,0,0-.21,0,.82.82,0,0,0-.24.1l-.17.12a.41.41,0,0,0-.1.14.28.28,0,0,0,0,.13.31.31,0,0,0,.13.12.51.51,0,0,0,.2.06.72.72,0,0,0,.25,0L131,389l.42-.13.41-.09a1.64,1.64,0,0,1,.38,0,2.41,2.41,0,0,1,.37.07,1.85,1.85,0,0,1,.38.18,1,1,0,0,1,.27.21.57.57,0,0,1,.12.23.37.37,0,0,1,0,.23.62.62,0,0,1-.15.22l.3.17s0,0,0,.07a0,0,0,0,1,0,.05l-.27.16h-.1a.2.2,0,0,1-.11,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,391.42a1.51,1.51,0,0,1-.41.09,1.8,1.8,0,0,1-.4,0,1.7,1.7,0,0,1-.35-.06,1.26,1.26,0,0,1-.28-.11.07.07,0,0,1-.06-.06.05.05,0,0,1,0-.05l.23-.14.11,0,.13,0a1.27,1.27,0,0,0,.34,0,.86.86,0,0,0,.38-.13.85.85,0,0,0,.14-.1.21.21,0,0,0,0-.24.27.27,0,0,0-.11-.1.64.64,0,0,0-.2-.08.6.6,0,0,0-.23,0,1.33,1.33,0,0,0-.29.07l-.4.12-.47.12a1.91,1.91,0,0,1-.41,0,1.51,1.51,0,0,1-.37-.07,2,2,0,0,1-.36-.17,1,1,0,0,1-.27-.21.42.42,0,0,1-.12-.24.34.34,0,0,1,0-.24.67.67,0,0,1,.19-.24l-.3-.17s0,0,0-.07a0,0,0,0,1,0-.05l.27-.16a.16.16,0,0,1,.1,0,.2.2,0,0,1,.11,0l.3.17a2.11,2.11,0,0,1,.38-.1,2.69,2.69,0,0,1,.4,0,1.75,1.75,0,0,1,.4.05,1.49,1.49,0,0,1,.37.14s.06,0,.06.06a0,0,0,0,1,0,.06l-.23.13a.25.25,0,0,1-.11,0l-.13,0-.17,0a.59.59,0,0,0-.19,0,.86.86,0,0,0-.21,0,1.12,1.12,0,0,0-.24.1l-.17.12a.28.28,0,0,0-.09.14.15.15,0,0,0,0,.13.34.34,0,0,0,.12.12.42.42,0,0,0,.21.06.69.69,0,0,0,.24,0l.32-.08.42-.13.41-.09a1.64,1.64,0,0,1,.38,0,1.53,1.53,0,0,1,.37.08,1.78,1.78,0,0,1,.38.17.84.84,0,0,1,.27.21.57.57,0,0,1,.12.23.36.36,0,0,1,0,.23.65.65,0,0,1-.16.22l.3.17a.13.13,0,0,1,.06.07.05.05,0,0,1,0,0l-.27.16a.13.13,0,0,1-.09,0,.18.18,0,0,1-.11,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.19,392.74a1.43,1.43,0,0,1-.41.09,1.79,1.79,0,0,1-.4,0,2,2,0,0,1-.35-.06l-.28-.1a.13.13,0,0,1-.06-.07.05.05,0,0,1,0-.05l.23-.14a.27.27,0,0,1,.12,0l.12,0a1.32,1.32,0,0,0,.35,0,.83.83,0,0,0,.37-.13.39.39,0,0,0,.14-.1.19.19,0,0,0,0-.24.4.4,0,0,0-.12-.1.56.56,0,0,0-.2-.08.61.61,0,0,0-.23,0,1.33,1.33,0,0,0-.29.07l-.4.12-.47.12a1.91,1.91,0,0,1-.41,0,1.51,1.51,0,0,1-.37-.07,2,2,0,0,1-.36-.17,1,1,0,0,1-.27-.21.39.39,0,0,1-.12-.24.34.34,0,0,1,0-.24.8.8,0,0,1,.19-.24l-.29-.17a.1.1,0,0,1-.06-.07s0,0,0,0l.26-.16a.16.16,0,0,1,.1,0,.2.2,0,0,1,.11,0l.3.17a2.36,2.36,0,0,1,.38-.1,2.73,2.73,0,0,1,.41,0,2.91,2.91,0,0,1,.4.05,1.66,1.66,0,0,1,.37.14l.06.06a.06.06,0,0,1,0,.06l-.24.13a.15.15,0,0,1-.11,0l-.12,0-.18,0h-.19a1,1,0,0,0-.21,0,.89.89,0,0,0-.23.1l-.18.12a.37.37,0,0,0-.09.14.15.15,0,0,0,0,.13.31.31,0,0,0,.13.12.36.36,0,0,0,.2.06.76.76,0,0,0,.25,0l.31-.08.42-.13.41-.09a1.73,1.73,0,0,1,.39,0,1.55,1.55,0,0,1,.36.08,1.59,1.59,0,0,1,.38.17,1.05,1.05,0,0,1,.27.21.51.51,0,0,1,.12.23.36.36,0,0,1,0,.23.54.54,0,0,1-.16.22l.3.17a.13.13,0,0,1,.06.07s0,0,0,0l-.26.16a.16.16,0,0,1-.1,0,.2.2,0,0,1-.11,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,368.3a1.41,1.41,0,0,1,.41,0c.2,0,.27.12.15.19l-11.55,6.67a1,1,0,0,1-.56,0c-.19,0-.26-.12-.15-.19l11.55-6.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79,367.19a1.41,1.41,0,0,1,.41,0c.19,0,.26.12.15.19l-11.55,6.67a1.08,1.08,0,0,1-.56.05c-.2,0-.26-.13-.15-.19l11.55-6.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,366.08a1.41,1.41,0,0,1,.41,0c.2,0,.27.12.15.19l-11.54,6.67a1.11,1.11,0,0,1-.56.05c-.2,0-.27-.13-.16-.19l11.55-6.67Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator-1--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.79,368.73a1.25,1.25,0,0,1,.73,1c0,.38,0,3.48,0,3.86a1.26,1.26,0,0,1-.73,1L181,390.09a3.86,3.86,0,0,1-3.53,0l-47.89-27.64a1.26,1.26,0,0,1-.73-1c0-.37,0-3.46,0-3.82a1.22,1.22,0,0,1,.73-1l26.84-15.5a3.92,3.92,0,0,1,3.53,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,358.61l47.89,27.65a3.86,3.86,0,0,0,3.53,0l26.84-15.49a1.08,1.08,0,0,0,0-2L159.9,341.08a3.92,3.92,0,0,0-3.53,0l-26.84,15.5A1.07,1.07,0,0,0,129.53,358.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,357.55a.22.22,0,0,1-.12.19L137.74,360a1.19,1.19,0,0,1-1-.13L133.36,358c-.22-.13-.34-.28-.34-.41v-1a.23.23,0,0,1,.12-.19l4-2.27a1.21,1.21,0,0,1,1,.12l3.34,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,356.58h0v1c0,.12.12.28.34.41l3.35,1.93a1.57,1.57,0,0,0,.59.19v-1a1.41,1.41,0,0,1-.59-.19L133.37,357C133.14,356.87,133,356.71,133,356.58Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,356.61a.19.19,0,0,1-.12.17l-3.94,2.28a.79.79,0,0,1-.45.06v1a.73.73,0,0,0,.44-.07l3.95-2.27a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,354.13l-4,2.27c-.22.13-.12.4.23.6l3.34,1.93a1.22,1.22,0,0,0,1,.13l3.94-2.28c.23-.13.13-.39-.22-.6l-3.34-1.93A1.21,1.21,0,0,0,137.09,354.13Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.85,353.49a.23.23,0,0,1-.12.19L144.78,356a1.19,1.19,0,0,1-1-.13l-3.35-1.93c-.22-.12-.34-.28-.34-.41v-1a.22.22,0,0,1,.12-.19l3.95-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.06,352.51h0v1c0,.13.12.29.34.41l3.35,1.93a1.41,1.41,0,0,0,.59.19v-.95a1.57,1.57,0,0,1-.59-.19l-3.34-1.93C140.18,352.81,140.06,352.65,140.06,352.51Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.85,352.54a.2.2,0,0,1-.12.18L144.79,355a.79.79,0,0,1-.45.06V356a.74.74,0,0,0,.44-.06l3.95-2.28a.2.2,0,0,0,.12-.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.13,350.06l-3.95,2.28c-.22.13-.12.4.22.6l3.35,1.93a1.22,1.22,0,0,0,1,.13l3.94-2.28c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,144.13,350.06Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89,349.43a.21.21,0,0,1-.12.18l-4,2.28a1.19,1.19,0,0,1-1-.13l-3.35-1.93c-.22-.13-.34-.28-.34-.41v-1a.23.23,0,0,1,.12-.19l3.95-2.27a1.18,1.18,0,0,1,1,.13l3.34,1.93c.22.13.34.28.34.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89,348.48a.21.21,0,0,1-.12.18l-3.94,2.27a.79.79,0,0,1-.45.06v1a.74.74,0,0,0,.44-.06l4-2.28a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,348.45h0v1c0,.13.12.28.34.41l3.35,1.93a1.57,1.57,0,0,0,.59.19v-1a1.41,1.41,0,0,1-.59-.19l-3.34-1.93C147.22,348.74,147.1,348.58,147.1,348.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,357.56a.2.2,0,0,1-.12.18L151.83,360a1.22,1.22,0,0,1-1-.13L147.45,358c-.22-.13-.34-.28-.34-.41v-1a.2.2,0,0,1,.12-.18l4-2.28a1.19,1.19,0,0,1,1,.13l3.35,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,356.61a.21.21,0,0,1-.12.18l-3.95,2.27a.66.66,0,0,1-.44.07v.95a.75.75,0,0,0,.44-.06l3.95-2.28a.2.2,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,356.58h0v1c0,.13.12.29.34.41l3.34,1.93a1.5,1.5,0,0,0,.6.19v-.95a1.68,1.68,0,0,1-.6-.19L147.45,357C147.23,356.87,147.11,356.72,147.11,356.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,349.43a.23.23,0,0,1-.12.19l-4,2.27a1.22,1.22,0,0,1-1-.13l-3.34-1.93c-.22-.12-.34-.28-.34-.41v-.95a.22.22,0,0,1,.12-.19l3.95-2.28a1.19,1.19,0,0,1,1,.13l3.35,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,348.48a.22.22,0,0,1-.12.18l-4,2.28a.74.74,0,0,1-.44.06V352a.76.76,0,0,0,.44-.06l3.94-2.27a.22.22,0,0,0,.13-.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,348.45h0v1c0,.13.12.29.34.41l3.34,1.93a1.5,1.5,0,0,0,.6.19V351a1.68,1.68,0,0,1-.6-.19l-3.34-1.93C161.31,348.75,161.19,348.59,161.19,348.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,353.5a.21.21,0,0,1-.12.18L158.87,356a1.22,1.22,0,0,1-1-.13l-3.34-1.93c-.22-.13-.34-.28-.34-.41v-1a.23.23,0,0,1,.12-.19l3.95-2.27a1.19,1.19,0,0,1,1,.12l3.35,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,352.55a.21.21,0,0,1-.12.18L158.87,355a.74.74,0,0,1-.44.06v1a.69.69,0,0,0,.44-.07l3.95-2.27a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.15,352.52h0v1c0,.12.12.28.34.41l3.34,1.93a1.68,1.68,0,0,0,.6.19v-1a1.5,1.5,0,0,1-.6-.19l-3.34-1.93C154.27,352.81,154.15,352.65,154.15,352.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,361.63a.2.2,0,0,1-.12.18l-3.94,2.28a1.22,1.22,0,0,1-1-.13L154.5,362c-.22-.13-.34-.28-.34-.41s0-.83,0-1a.23.23,0,0,1,.12-.19l3.94-2.27a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.28.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,360.68a.21.21,0,0,1-.12.18l-3.94,2.27a.79.79,0,0,1-.45.06v1a.79.79,0,0,0,.45-.06l3.94-2.28a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,360.65h0c0,.13,0,.88,0,1s.13.28.35.41l3.34,1.93a1.46,1.46,0,0,0,.59.19v-1a1.32,1.32,0,0,1-.59-.19l-3.34-1.93C154.27,360.94,154.15,360.78,154.16,360.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,353.5a.2.2,0,0,1-.12.18L173,356a1.22,1.22,0,0,1-1-.13l-3.34-1.93c-.22-.13-.34-.28-.35-.41s0-.83,0-1a.19.19,0,0,1,.12-.18l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,352.55a.21.21,0,0,1-.12.18L173,355a.71.71,0,0,1-.45.07V356A.79.79,0,0,0,173,356l3.94-2.28a.2.2,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,352.52h0c0,.13,0,.88,0,1s.12.28.35.41l3.34,1.93a1.46,1.46,0,0,0,.59.19v-.95a1.63,1.63,0,0,1-.59-.19L168.58,353C168.35,352.81,168.23,352.65,168.24,352.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,357.56a.22.22,0,0,1-.12.19L165.92,360a1.21,1.21,0,0,1-1-.12L161.54,358a.63.63,0,0,1-.35-.42c0-.07,0-.82,0-.95a.22.22,0,0,1,.12-.19l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,356.62a.19.19,0,0,1-.12.17l-3.94,2.28a.79.79,0,0,1-.45.06v1a.78.78,0,0,0,.45-.07l3.94-2.27a.22.22,0,0,0,.12-.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2,356.59h0c0,.13,0,.88,0,.95a.63.63,0,0,0,.35.42l3.34,1.93a1.63,1.63,0,0,0,.59.19v-1a1.46,1.46,0,0,1-.59-.19L161.54,357C161.31,356.88,161.19,356.72,161.2,356.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,365.7a.21.21,0,0,1-.12.18l-4,2.28a1.19,1.19,0,0,1-1-.13l-3.35-1.93c-.22-.13-.34-.28-.34-.41v-1a.23.23,0,0,1,.12-.19l4-2.27a1.18,1.18,0,0,1,1,.13l3.34,1.93c.22.12.34.28.34.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,364.75a.21.21,0,0,1-.12.18l-3.94,2.27a.79.79,0,0,1-.45.06v1a.66.66,0,0,0,.44-.07l4-2.27a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2,364.72h0v1c0,.13.12.28.34.41l3.35,1.93a1.57,1.57,0,0,0,.59.19v-1a1.41,1.41,0,0,1-.59-.19l-3.34-1.93C161.32,365,161.2,364.85,161.2,364.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,357.57a.21.21,0,0,1-.12.18L180,360a1.19,1.19,0,0,1-1-.13L175.62,358c-.22-.13-.34-.28-.34-.41v-1a.23.23,0,0,1,.12-.19l3.95-2.27a1.22,1.22,0,0,1,1,.13l3.34,1.93c.22.13.34.28.34.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,356.62a.21.21,0,0,1-.12.18L180,359.07a.79.79,0,0,1-.45.06v1A.74.74,0,0,0,180,360l3.95-2.28a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,356.59h0v1c0,.13.12.28.34.41L179,359.9a1.41,1.41,0,0,0,.59.19v-1a1.28,1.28,0,0,1-.59-.19L175.63,357C175.4,356.88,175.28,356.72,175.28,356.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,361.63a.23.23,0,0,1-.12.19L173,364.09a1.19,1.19,0,0,1-1-.13L168.58,362c-.22-.12-.34-.28-.34-.41v-.95a.22.22,0,0,1,.12-.19l3.95-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,360.68a.19.19,0,0,1-.12.18L173,363.14a.79.79,0,0,1-.45.06v.95a.74.74,0,0,0,.44-.06l3.95-2.27a.23.23,0,0,0,.12-.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,360.65v1c0,.13.12.29.34.41l3.35,1.93a1.28,1.28,0,0,0,.59.19v-.95a1.57,1.57,0,0,1-.59-.19l-3.34-1.93C168.36,361,168.24,360.79,168.24,360.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,345.36a.23.23,0,0,1-.12.19l-3.95,2.27a1.16,1.16,0,0,1-1-.13l-3.35-1.93c-.22-.12-.34-.28-.34-.41v-1a.22.22,0,0,1,.12-.19l4-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,344.38v1c0,.13.12.29.34.41l3.34,1.93a1.36,1.36,0,0,0,.6.19v-.95a1.41,1.41,0,0,1-.59-.19l-3.34-1.93C154.26,344.68,154.14,344.52,154.14,344.38Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,344.41a.19.19,0,0,1-.12.18l-3.94,2.28a.79.79,0,0,1-.45.06v.95a.74.74,0,0,0,.44-.06l3.95-2.27a.23.23,0,0,0,.12-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,341.93l-4,2.28c-.22.13-.12.4.22.6l3.35,1.93a1.21,1.21,0,0,0,1,.13l3.94-2.28c.22-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,158.21,341.93Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,361.62a.22.22,0,0,1-.12.19l-4,2.27a1.21,1.21,0,0,1-1-.12L140.41,362c-.22-.13-.34-.29-.34-.42v-.95a.22.22,0,0,1,.12-.19l3.95-2.27a1.19,1.19,0,0,1,1,.12l3.35,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,360.65h0v1c0,.12.12.28.34.41l3.34,1.93a1.68,1.68,0,0,0,.6.19v-1a1.5,1.5,0,0,1-.6-.19l-3.34-1.93C140.19,360.94,140.07,360.78,140.07,360.65Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,360.68a.19.19,0,0,1-.12.17l-4,2.28a.74.74,0,0,1-.44.06v1a.75.75,0,0,0,.44-.07l4-2.27a.22.22,0,0,0,.12-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,358.2l-3.95,2.27c-.22.13-.12.4.22.6l3.35,1.93a1.19,1.19,0,0,0,1,.13l4-2.28c.22-.13.12-.4-.22-.6l-3.35-1.93A1.19,1.19,0,0,0,144.14,358.2Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,365.69a.23.23,0,0,1-.13.19l-3.94,2.27a1.21,1.21,0,0,1-1-.12l-3.34-1.93c-.22-.13-.34-.29-.34-.42v-.95a.22.22,0,0,1,.12-.19l3.94-2.27a1.17,1.17,0,0,1,1,.12l3.35,1.93c.22.13.34.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,364.72h0v.95c0,.13.12.29.34.42L150.8,368a1.68,1.68,0,0,0,.6.19v-1a1.5,1.5,0,0,1-.6-.19l-3.34-1.93C147.23,365,147.11,364.85,147.12,364.72Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,364.75a.23.23,0,0,1-.12.17l-3.95,2.28a.75.75,0,0,1-.44.06v1a.76.76,0,0,0,.44-.07l3.94-2.27a.23.23,0,0,0,.13-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.18,362.27l-3.94,2.27c-.23.13-.13.4.22.6l3.34,1.93a1.22,1.22,0,0,0,1,.13l3.95-2.28c.22-.13.12-.4-.22-.6l-3.35-1.93A1.17,1.17,0,0,0,151.18,362.27Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,369.76a.22.22,0,0,1-.12.19l-3.94,2.27a1.21,1.21,0,0,1-1-.12l-3.34-1.94c-.22-.12-.34-.28-.34-.41v-.95a.22.22,0,0,1,.12-.19l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.29.35.42S163,369.63,163,369.76Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17,368.79h0v.95c0,.13.12.29.34.42l3.34,1.93a1.63,1.63,0,0,0,.59.19v-1a1.46,1.46,0,0,1-.59-.19l-3.34-1.93C154.28,369.08,154.16,368.92,154.17,368.79Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,368.82a.22.22,0,0,1-.13.17l-3.94,2.28a.79.79,0,0,1-.45.06v1a.87.87,0,0,0,.45-.07l3.94-2.27a.22.22,0,0,0,.12-.19C163,369.63,163,368.91,163,368.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,366.33l-3.94,2.28c-.23.13-.13.4.22.6l3.34,1.93a1.22,1.22,0,0,0,1,.13l3.94-2.28c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,158.23,366.33Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,361.64a.2.2,0,0,1-.12.18l-3.94,2.28a1.22,1.22,0,0,1-1-.13L182.67,362c-.22-.13-.34-.28-.34-.41s0-.83,0-1a.2.2,0,0,1,.13-.18l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.22.13.35.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,360.66h0v1c0,.13.12.28.34.41L186,364a1.46,1.46,0,0,0,.59.19v-1A1.63,1.63,0,0,1,186,363l-3.34-1.93C182.45,361,182.33,360.79,182.34,360.66Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,360.69a.21.21,0,0,1-.12.18l-3.94,2.27a.71.71,0,0,1-.45.07v1a.79.79,0,0,0,.45-.06l3.94-2.28a.2.2,0,0,0,.12-.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,358.21l-3.94,2.28c-.23.13-.13.39.22.6L186,363a1.21,1.21,0,0,0,1,.12l3.94-2.27c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,186.4,358.21Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,365.7a.22.22,0,0,1-.12.19L180,368.16a1.21,1.21,0,0,1-1-.12l-3.34-1.93c-.23-.13-.35-.29-.35-.42s0-.82,0-.95a.21.21,0,0,1,.13-.19l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,364.73h0c0,.13,0,.88,0,.95s.12.29.34.42L179,368a1.63,1.63,0,0,0,.59.19v-1a1.46,1.46,0,0,1-.59-.19l-3.34-1.93C175.41,365,175.29,364.86,175.3,364.73Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,364.76a.19.19,0,0,1-.12.17L180,367.21a.79.79,0,0,1-.45.06v1a.78.78,0,0,0,.45-.07l3.94-2.27a.22.22,0,0,0,.12-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,362.27l-3.94,2.28c-.23.13-.13.4.22.6l3.34,1.93a1.22,1.22,0,0,0,1,.13l3.94-2.28c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,179.36,362.27Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,369.77a.2.2,0,0,1-.12.18L173,372.23a1.22,1.22,0,0,1-1-.13l-3.34-1.93c-.23-.13-.35-.28-.35-.41s0-.83,0-1a.19.19,0,0,1,.12-.19l3.94-2.27a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.28.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26,368.79h0c0,.13,0,.88,0,1s.12.28.34.41l3.35,1.93a1.46,1.46,0,0,0,.59.19v-1a1.32,1.32,0,0,1-.59-.19l-3.34-1.93C168.37,369.08,168.25,368.92,168.26,368.79Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,368.82a.21.21,0,0,1-.12.18L173,371.27a.79.79,0,0,1-.45.06v1a.79.79,0,0,0,.45-.06l3.94-2.28a.21.21,0,0,0,.12-.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,366.34l-3.94,2.27c-.23.13-.13.4.22.6l3.34,1.93a1.18,1.18,0,0,0,1,.13l3.94-2.27c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,172.32,366.34Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,373.83a.23.23,0,0,1-.12.19l-3.94,2.27a1.18,1.18,0,0,1-1-.13l-3.34-1.93c-.22-.12-.35-.28-.35-.41s0-.82,0-.95a.2.2,0,0,1,.12-.19l3.94-2.28a1.22,1.22,0,0,1,1,.13l3.34,1.93c.23.13.35.29.34.42Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.22,372.85v0c0,.13,0,.88,0,.95s.12.29.35.41l3.34,1.93a1.32,1.32,0,0,0,.59.19v-1a1.46,1.46,0,0,1-.59-.19l-3.34-1.93C161.33,373.15,161.21,373,161.22,372.85Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,372.88a.19.19,0,0,1-.12.18l-3.94,2.28a.79.79,0,0,1-.45.06v1a.79.79,0,0,0,.45-.06l3.94-2.27a.23.23,0,0,0,.12-.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.28,370.4l-3.94,2.28c-.23.13-.13.4.22.6l3.34,1.93a1.22,1.22,0,0,0,1,.13l3.94-2.28c.23-.13.13-.4-.22-.6l-3.34-1.93A1.22,1.22,0,0,0,165.28,370.4Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.12,356.12l0,0,1,1.18.68-.4H181l.08,0,.32.19s0,0,0,0,0,0,0,0l-1.09.64h-.07l-.08,0-.28-.17-.12-.11-1-1.18a.08.08,0,0,1,0,0s0,0,0,0l.32-.19h.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.79,360.85a.7.7,0,0,1,.22.19.35.35,0,0,1,.07.2.36.36,0,0,1-.06.2.67.67,0,0,1-.2.17,1.34,1.34,0,0,1-.3.12,2,2,0,0,1-.34,0,1.49,1.49,0,0,1-.36,0,1.24,1.24,0,0,1-.32-.12.79.79,0,0,1-.19-.15.47.47,0,0,1-.1-.16,1.67,1.67,0,0,1-.31-.05,1.48,1.48,0,0,1-.29-.12.6.6,0,0,1-.22-.19.32.32,0,0,1-.07-.2.37.37,0,0,1,.08-.21,1,1,0,0,1,.21-.18,1.12,1.12,0,0,1,.32-.12,1.34,1.34,0,0,1,.35-.05,1.47,1.47,0,0,1,.36,0,1.2,1.2,0,0,1,.33.13.58.58,0,0,1,.2.17.31.31,0,0,1,.09.18.86.86,0,0,1,.27.05A1.19,1.19,0,0,1,173.79,360.85Zm-1.25-.27a.38.38,0,0,0-.22-.05.52.52,0,0,0-.25.08c-.08.05-.13.09-.13.14a.14.14,0,0,0,.09.12.36.36,0,0,0,.21.05.5.5,0,0,0,.25-.07c.08-.05.13-.1.13-.15A.14.14,0,0,0,172.54,360.58Zm.83.52a.46.46,0,0,0-.21-.05.43.43,0,0,0-.22.06c-.07,0-.1.08-.1.13s0,.08.09.11a.37.37,0,0,0,.21.06.43.43,0,0,0,.22-.06c.07,0,.1-.08.1-.13A.14.14,0,0,0,173.37,361.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,364.84a.89.89,0,0,1,.27.22.51.51,0,0,1,.09.22.31.31,0,0,1-.07.21.59.59,0,0,1-.2.18.82.82,0,0,1-.3.11,1.5,1.5,0,0,1-.37,0,1.89,1.89,0,0,1-.39-.05,1.69,1.69,0,0,1-.37-.15,1,1,0,0,1-.15-.11.47.47,0,0,1-.1-.1.61.61,0,0,1-.07-.1l-.06-.1-.37-.72a.08.08,0,0,0,0,0s0,0,0,0l.37-.21h0l.06,0,0,0h0l.26.49a1.71,1.71,0,0,1,.29-.08,1.9,1.9,0,0,1,.34,0l.35.06A1.56,1.56,0,0,1,166.67,364.84Zm-.92.53.13.05a.36.36,0,0,0,.14,0h.14l.11,0a.27.27,0,0,0,.08-.07.19.19,0,0,0,0-.08.16.16,0,0,0,0-.08.22.22,0,0,0-.09-.07.38.38,0,0,0-.13-.06H166a.29.29,0,0,0-.13,0l-.11,0a.27.27,0,0,0-.08.07.19.19,0,0,0,0,.07.16.16,0,0,0,0,.09A.35.35,0,0,0,165.75,365.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,352.29h.07l.08,0,.31.18.72-.42h.07s.06,0,.08,0l.32.18a.19.19,0,0,1,.1.1l.47,1.06a.11.11,0,0,1,0,.05l0,0-.35.2h-.06l-.08,0-1.17-.68-.2.11a.08.08,0,0,1-.07,0l-.08,0-.32-.19s0,0,0,0,0,0,0,0l.2-.11-.32-.18,0-.05,0,0Zm.94.48.56.33-.23-.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49,356.53l-.09,0h-.22l-.11,0a.16.16,0,0,0-.07.07.09.09,0,0,0,0,.07.13.13,0,0,0,0,.08l.1.08a.41.41,0,0,0,.23.06.46.46,0,0,0,.23-.06l.05,0s0,0,0-.05l0,0s0,0,0,0l.36-.21a.08.08,0,0,1,.07,0l.08,0,1,.67,0,.05s0,0,0,0l-1,.57a.08.08,0,0,1-.07,0l-.08,0-.32-.19s0,0,0,0,0,0,0,0l.67-.39-.26-.16,0,.08a.39.39,0,0,1-.1.08,1.34,1.34,0,0,1-.3.12,1.87,1.87,0,0,1-.34,0,1.51,1.51,0,0,1-.35-.06,1.38,1.38,0,0,1-.36-.15.89.89,0,0,1-.27-.22.41.41,0,0,1-.1-.21.31.31,0,0,1,.07-.21.63.63,0,0,1,.21-.18,1.51,1.51,0,0,1,.33-.13,1.47,1.47,0,0,1,.36,0,1.75,1.75,0,0,1,.33.05,1.33,1.33,0,0,1,.3.11s0,0,0,0,0,0,0,0l-.29.17-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.62,361.18a1,1,0,0,1-.26-.21.4.4,0,0,1-.09-.23.34.34,0,0,1,.06-.21.63.63,0,0,1,.21-.18.82.82,0,0,1,.32-.12,1.45,1.45,0,0,1,.37,0,1.35,1.35,0,0,1,.39.05,1.31,1.31,0,0,1,.37.15l.16.11.1.11.07.11.06.09.35.71a.08.08,0,0,0,0,0s0,0,0,0l-.37.21h0l-.06,0,0,0h0l-.24-.49a1.26,1.26,0,0,1-.31.09,1.88,1.88,0,0,1-.34,0,2.14,2.14,0,0,1-.35-.06A1.54,1.54,0,0,1,157.62,361.18Zm.95-.54a.35.35,0,0,0-.14-.06h-.29l-.11.05-.08.06a.16.16,0,0,0,0,.08.16.16,0,0,0,0,.09.29.29,0,0,0,.1.08l.14.05a.39.39,0,0,0,.15,0,.3.3,0,0,0,.13,0l.12,0a.23.23,0,0,0,.07-.07.11.11,0,0,0,0-.08.13.13,0,0,0,0-.08A.27.27,0,0,0,158.57,360.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,348.72l.07,0s0,0,0,.05l0,.57a.09.09,0,0,1,0,.05.05.05,0,0,1,0,.05l-.28.17h-.07l-.08,0-2-1.14s0,0,0,0,0,0,0,0l.3-.17.07,0s.05,0,.07,0L166,349v-.32a0,0,0,0,1,0,0h.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,353.41l-.16-.1-.12-.12a.35.35,0,0,1-.06-.14.32.32,0,0,1,0-.17v-.37l-.57.33a.08.08,0,0,1-.07,0l-.08,0-.32-.19s0,0,0,0,0,0,0,0l1.21-.7h.07l.07,0,.27.16a.24.24,0,0,1,.08.06.13.13,0,0,1,0,.08l0,.77a.2.2,0,0,0,0,.14.31.31,0,0,0,.11.09l.07,0,.1,0h.12a.2.2,0,0,0,.13,0,.15.15,0,0,0,.08-.08.17.17,0,0,0,0-.07l0-.06,0,0s0,0,0-.06l0,0,.28-.16h.06l.06,0a.92.92,0,0,1,.21.17.53.53,0,0,1,.12.2.39.39,0,0,1,0,.21.54.54,0,0,1-.22.2,1,1,0,0,1-.32.12,1.45,1.45,0,0,1-.36,0,2,2,0,0,1-.34-.06A1.26,1.26,0,0,1,158.36,353.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,357.84a.08.08,0,0,1-.07,0l-.07,0-.33-.19,0,0,0,0-.09-.38a1.4,1.4,0,0,1-.5.05,1.17,1.17,0,0,1-.5-.16c-.23-.13-.34-.27-.34-.4s.11-.27.33-.39a1.3,1.3,0,0,1,.69-.18,1.69,1.69,0,0,1,.33,0,.85.85,0,0,1,.27.1l0,0,0,0-.29.17-.1,0h-.26a.44.44,0,0,0-.17.06.27.27,0,0,0-.14.14s0,.09.09.13a.46.46,0,0,0,.23.05.7.7,0,0,0,.23-.08l.19-.11a.08.08,0,0,1,.07,0l.07,0,.27.15,0,0s0,0,0,0l.08.33.6-.34a.08.08,0,0,1,.07,0l.07,0,.33.19,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.67,349.4a.93.93,0,0,1-.36.14,1.7,1.7,0,0,1-.39,0,1.61,1.61,0,0,1-.38-.08,2.43,2.43,0,0,1-.37-.16l-.28-.15-.26-.16a1.59,1.59,0,0,1-.27-.21.54.54,0,0,1-.14-.22.31.31,0,0,1,0-.23.68.68,0,0,1,.23-.21,1.2,1.2,0,0,1,.36-.13,1.28,1.28,0,0,1,.39,0,1.61,1.61,0,0,1,.38.08,1.73,1.73,0,0,1,.37.16,1.82,1.82,0,0,1,.27.15l.27.16a1.59,1.59,0,0,1,.27.21.58.58,0,0,1,.15.22.31.31,0,0,1,0,.23A.52.52,0,0,1,152.67,349.4Zm-1.6-.64q.26.17.51.3l.16.07.15,0H152a.24.24,0,0,0,.14-.05.15.15,0,0,0,.09-.08.14.14,0,0,0,0-.09l-.07-.08-.13-.09a4.27,4.27,0,0,0-.51-.3l-.16-.07a.42.42,0,0,0-.15,0h-.15a.27.27,0,0,0-.14.05.15.15,0,0,0-.09.08.11.11,0,0,0,0,.08l.07.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25,360.11h.08l.72.17-1-.58s0,0,0,0,0,0,0,0l.3-.17h.06l.08,0,2,1.14a.1.1,0,0,1,0,0,.08.08,0,0,1,0,0l-.27.15a.16.16,0,0,1-.1,0H189l-1.22-.28.48.71s0,0,0,0a.07.07,0,0,1,0,.06l-.27.16h-.06s-.06,0-.08,0l-2-1.14,0,0a.05.05,0,0,1,0,0l.3-.17.07,0s.06,0,.08,0l1,.58-.29-.41,0-.05s0,0,0-.05l.15-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42,361.5l-.11-.07-.14-.08-.15-.08-.12-.07-.15-.06-.16,0h-.17a.52.52,0,0,0-.16.06s-.09.05-.1.08a.16.16,0,0,0,0,.09l0,.07.06.06,0,0s0,0,0,.05l-.3.17h-.06l-.06,0a1,1,0,0,1-.24-.2.43.43,0,0,1-.08-.23.31.31,0,0,1,.06-.22.72.72,0,0,1,.22-.2,1.4,1.4,0,0,1,.36-.13,1.79,1.79,0,0,1,.4,0,1.47,1.47,0,0,1,.41.07,2,2,0,0,1,.37.15l.28.15.27.16a1,1,0,0,1,.26.22.6.6,0,0,1,.13.23.35.35,0,0,1-.05.24.58.58,0,0,1-.23.2.93.93,0,0,1-.34.13,1.58,1.58,0,0,1-.38,0,1.74,1.74,0,0,1-.39-.05,1.22,1.22,0,0,1-.35-.14l0,0s0,0,0,0l.3-.18.07,0,.1,0,.1,0,.13,0,.14,0,.15-.06a.26.26,0,0,0,.11-.09.16.16,0,0,0,0-.1.28.28,0,0,0-.07-.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.19,364.18l.09,0,.72.16-1-.58,0,0a.08.08,0,0,1,0,0l.3-.17h.07l.08,0,2,1.14s0,0,0,.05,0,0,0,0l-.27.15a.18.18,0,0,1-.1,0H182l-1.22-.27.47.7a.05.05,0,0,1,0,0,0,0,0,0,1,0,.06l-.27.16h-.07l-.07,0-2-1.15,0,0s0,0,0,0l.3-.17a.08.08,0,0,1,.07,0l.08,0,1,.58-.29-.41s0,0,0-.05,0,0,0-.05l.15-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,366.22a1.44,1.44,0,0,1-.32.13,1.26,1.26,0,0,1-.33,0,1.48,1.48,0,0,1-.35,0,2.14,2.14,0,0,1-.35-.16.84.84,0,0,1-.31-.26.28.28,0,0,1,0-.25l-1-.25,0,0,0,0,0,0,.31-.18a.15.15,0,0,1,.09,0h.09l.91.23.21-.12-.65-.38s0,0,0,0,0,0,0,0l.3-.17a.06.06,0,0,1,.06,0l.08,0,2,1.14,0,0a.05.05,0,0,1,0,0Zm-.67-.68-.26.15a.2.2,0,0,0-.11.12s0,.09.11.14a.39.39,0,0,0,.24.06.37.37,0,0,0,.21-.06l.26-.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89,368.4H173l.72.17-1-.58s0,0,0-.05,0,0,0,0l.3-.17H173l.08,0,2,1.14,0,.05a.08.08,0,0,1,0,0l-.27.15a.16.16,0,0,1-.1,0h-.08l-1.22-.28.48.71,0,0s0,0,0,.06l-.27.16h-.06a.11.11,0,0,1-.08,0l-2-1.14a.08.08,0,0,1,0,0,.05.05,0,0,1,0,0l.3-.17a.08.08,0,0,1,.07,0l.08,0,1,.58-.29-.41,0-.05s0,0,0-.05l.15-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,369.22h.07l.08,0,.31.18a.1.1,0,0,1,0,0s0,0,0,0l-.72.42a.08.08,0,0,1-.07,0l-.08,0-.31-.18,0,0a.05.05,0,0,1,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,372.37h.09l.72.16-1-.58,0,0a.05.05,0,0,1,0,0l.3-.18h.07l.08,0,2,1.15s0,0,0,0,0,0,0,0l-.26.15a.12.12,0,0,1-.1,0h-.08l-1.22-.27.47.7a.06.06,0,0,1,0,.05s0,0,0,.06l-.27.15h-.07l-.07,0-2-1.14,0-.05a0,0,0,0,1,0,0l.3-.17H165l.08,0,1,.59-.29-.42a.08.08,0,0,1,0-.05s0,0,0,0l.14-.09A.11.11,0,0,1,166,372.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,373.6l-.51-.29s0,0,0,0a.05.05,0,0,1,0,0l.29-.17H164l.08,0,.5.29.36-.2a.08.08,0,0,1,.07,0l.07,0,.31.18s0,0,0,0,0,0,0,0l-.35.21.5.29s0,0,0,0,0,0,0,0l-.29.17h-.07l-.07,0-.51-.3-.35.21h-.07l-.07,0-.31-.18a.05.05,0,0,1,0-.05s0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1,368.59l.07,0s.05,0,.07,0l.31.18s0,0,0,0,0,0,0,0l-1.36.79h-.07l-.08,0-.3-.18s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,369.74c-.17-.1-.2-.23-.08-.31a.6.6,0,0,1,.53.05c.17.09.2.23.08.3A.56.56,0,0,1,159.28,369.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,368.73a.6.6,0,0,0,.53,0c.12-.08.09-.21-.08-.31a.63.63,0,0,0-.53,0C157.34,368.5,157.37,368.64,157.54,368.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.88,364.87l.69.06.08,0,0,0,.07.28a.08.08,0,0,1,0,0h-.07l-.7-.06.1.4s0,0,0,0H152l-.48,0-.08,0,0,0-.1-.4-.68-.05-.08,0,0-.05-.07-.27a.05.05,0,0,1,0,0,.08.08,0,0,1,.07,0l.69.05-.1-.4a0,0,0,0,1,0,0h.07l.47,0,.08,0,0,.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,360.44a.06.06,0,0,1,.06,0l.08,0,.31.18a.08.08,0,0,1,0,0s0,0,0,0l-1.37.79H144l-.08,0-.31-.18,0-.05a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.26,345a.14.14,0,0,1-.11,0l-.1,0-2.43-.82-.05,0a.05.05,0,0,1,0,0s0,0,0,0l.29-.17a.15.15,0,0,1,.09,0H158l.32.11.61-.35-.19-.18a.05.05,0,0,1,0,0,.07.07,0,0,1,0-.06l.29-.16a0,0,0,0,1,0,0l.07,0,0,0,1.43,1.4a.07.07,0,0,1,0,.06s0,0,0,.06Zm-1-1-.37.22.92.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.31,345.17l-.1-.06-.15-.09-.14-.08-.12-.06-.16-.07-.16,0h-.16a.44.44,0,0,0-.16.06.26.26,0,0,0-.11.09.12.12,0,0,0,0,.08.11.11,0,0,0,0,.07.1.1,0,0,0,.05.06s0,0,0,.06,0,0,0,0l-.3.17h0l-.07,0a.77.77,0,0,1-.23-.2.35.35,0,0,1-.09-.22.41.41,0,0,1,.07-.23.52.52,0,0,1,.22-.19,1.13,1.13,0,0,1,.36-.14,1.76,1.76,0,0,1,.4,0,1.87,1.87,0,0,1,.4.07,2.15,2.15,0,0,1,.38.15l.27.16a1.75,1.75,0,0,1,.27.16,1.2,1.2,0,0,1,.27.21.45.45,0,0,1,.12.24.32.32,0,0,1,0,.23.68.68,0,0,1-.23.21,1,1,0,0,1-.34.12,1.71,1.71,0,0,1-.78,0,1.33,1.33,0,0,1-.35-.13.05.05,0,0,1,0,0,0,0,0,0,1,0,0l.3-.18a.11.11,0,0,1,.08,0l.09,0,.11,0,.12,0,.15,0,.15-.06a.22.22,0,0,0,.1-.09.1.1,0,0,0,0-.09.21.21,0,0,0-.06-.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32,352.54a.08.08,0,0,1,.07,0l.08,0,.31.18,0,0a.05.05,0,0,1,0,0l-1.31.75a.06.06,0,0,1-.06,0l-.08,0-.31-.18s0,0,0,0,0,0,0,0Zm-.75-.44h.07a.09.09,0,0,1,.07,0l.31.17s0,0,0,0,0,0,0,0l-1.3.75h-.07l-.07,0-.31-.18s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05,356.88l-.51-.29,0,0s0,0,0,0l.29-.17h.07l.08,0,.5.29.36-.2a.06.06,0,0,1,.06,0l.08,0,.31.18,0,0s0,0,0,0l-.36.21.51.29,0,0s0,0,0,0l-.29.17h-.07l-.07,0-.51-.3-.35.21h-.07l-.08,0-.31-.18a.1.1,0,0,1,0-.05l0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,386.69a3.55,3.55,0,0,1-1.78-.43l-47.89-27.65a1.25,1.25,0,0,1-.73-1c0,.43,0,3.44,0,3.81a1.26,1.26,0,0,0,.73,1l47.89,27.64a3.54,3.54,0,0,0,1.77.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,369.75v0a1.23,1.23,0,0,1-.74,1L181,386.26a3.68,3.68,0,0,1-1.75.43v3.83a3.61,3.61,0,0,0,1.76-.43l26.83-15.49a1.25,1.25,0,0,0,.74-1C208.53,373.22,208.52,370.12,208.52,369.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.78,363.66h0a.8.8,0,0,0-.44.11l-24.51,14.15c-.25.14-.25.37,0,.51l9.93,5.73a1,1,0,0,0,.88,0L193.76,376Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,369.5l-9.93-5.73a.9.9,0,0,0-.44-.11l0,12.34,10-5.77.39-.22A.27.27,0,0,0,204.15,369.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.76,370.23l-9.54-5.51a1,1,0,0,0-.89,0l-24.12,13.93,9.54,5.51a1,1,0,0,0,.88,0Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.76,370.23l-9.54-5.51a1,1,0,0,0-.89,0l-24.12,13.93,9.54,5.51a1,1,0,0,0,.88,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.91,368.53l.86-.5a1.6,1.6,0,0,1,.94-.16,2.53,2.53,0,0,1,1.07.33.23.23,0,0,1,.13.15c0,.06,0,.1-.06.14a.55.55,0,0,1-.24,0,.54.54,0,0,1-.26-.09,1.36,1.36,0,0,0-.54-.16.85.85,0,0,0-.47.08l-.86.5a.24.24,0,0,0-.14.27.51.51,0,0,0,.28.31l.73.42a.51.51,0,0,1,.28-.34l.86-.5a1.6,1.6,0,0,1,.94-.15,2.53,2.53,0,0,1,1.07.32l.57.33a1.07,1.07,0,0,1,.56.61.46.46,0,0,1-.27.55l-.86.5a1.63,1.63,0,0,1-.95.16,2.49,2.49,0,0,1-1.06-.33l-2.3-1.32a1.09,1.09,0,0,1-.56-.62A.47.47,0,0,1,191.91,368.53Zm3,2.23a1.15,1.15,0,0,0,.53.17.85.85,0,0,0,.47-.08l.86-.5a.23.23,0,0,0,.14-.27.51.51,0,0,0-.28-.31l-.57-.33a1.21,1.21,0,0,0-.53-.16.79.79,0,0,0-.48.08l-.86.49a.23.23,0,0,0-.13.28.48.48,0,0,0,.27.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.77,371.51a.28.28,0,0,0-.13,0,.16.16,0,0,0-.12,0l-1.19.68a1.58,1.58,0,0,1-.94.16,2.36,2.36,0,0,1-1.06-.33l-.58-.33a1.08,1.08,0,0,1-.56-.61.48.48,0,0,1,.28-.55l.86-.49a1.58,1.58,0,0,1,.94-.16,2.48,2.48,0,0,1,1.06.32.28.28,0,0,1,.15.16.12.12,0,0,1-.08.13.32.32,0,0,1-.23,0,.53.53,0,0,1-.27-.08,1.27,1.27,0,0,0-.53-.16.77.77,0,0,0-.47.08l-.86.5a.24.24,0,0,0-.14.27.62.62,0,0,0,.28.31l.58.33a1.31,1.31,0,0,0,.53.16.83.83,0,0,0,.47-.08l1.29-.75a.85.85,0,0,1,.47-.07,1.22,1.22,0,0,1,.54.16l1.43.82c.08.05.13.1.14.16s0,.1-.07.13l-2.15,1.25a.53.53,0,0,1-.23,0,.77.77,0,0,1-.27-.08.3.3,0,0,1-.14-.16.12.12,0,0,1,.07-.13l1.83-1.06a.05.05,0,0,0,0-.07s0-.05-.07-.08Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185,372.5l.87-.5a1.67,1.67,0,0,1,.94-.15,2.48,2.48,0,0,1,1.06.32l2.3,1.33a1.08,1.08,0,0,1,.56.61.46.46,0,0,1-.28.54l-.86.5a1.58,1.58,0,0,1-.94.16,2.48,2.48,0,0,1-1.06-.32l-2.3-1.33a1.07,1.07,0,0,1-.56-.61A.48.48,0,0,1,185,372.5Zm1.44-.16-.86.49a.28.28,0,0,0-.13.16l4.24.73-2.25-1.3a1.18,1.18,0,0,0-.53-.16A.77.77,0,0,0,186.46,372.34Zm2.58,2.48.86-.5a.23.23,0,0,0,.13-.16l-4.24-.72,2.25,1.3a1.27,1.27,0,0,0,.53.16A.85.85,0,0,0,189,374.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.8,374.36l1.29-.74a.36.36,0,0,1,.24,0,.61.61,0,0,1,.26.08.23.23,0,0,1,.14.15c0,.06,0,.1-.06.14l-.43.25,2.86,1.65a1.21,1.21,0,0,0,.53.16.77.77,0,0,0,.47-.07h0a.34.34,0,0,1,.23,0,.5.5,0,0,1,.27.08.25.25,0,0,1,.14.15.13.13,0,0,1-.07.14h0a1.6,1.6,0,0,1-.94.15,2.53,2.53,0,0,1-1.07-.32l-2.86-1.65-.43.24a.37.37,0,0,1-.24,0,.61.61,0,0,1-.27-.08.28.28,0,0,1-.14-.15A.13.13,0,0,1,181.8,374.36Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179,376l.86-.5a1.62,1.62,0,0,1,.95-.15,2.52,2.52,0,0,1,1.06.32l2.29,1.32a1,1,0,0,1,.56.62.45.45,0,0,1-.27.54l-.86.5a1.6,1.6,0,0,1-.94.16,2.53,2.53,0,0,1-1.07-.33l-2.29-1.32a1.06,1.06,0,0,1-.56-.62A.45.45,0,0,1,179,376Zm1.44-.17-.86.5a.27.27,0,0,0-.14.16l4.25.72-2.25-1.29a1.23,1.23,0,0,0-.53-.17A.81.81,0,0,0,180.44,375.81ZM183,378.3l.86-.5a.26.26,0,0,0,.13-.16l-4.24-.72,2.24,1.29a1.23,1.23,0,0,0,.54.17A.85.85,0,0,0,183,378.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.85,378.48a.11.11,0,0,1,.07-.14.33.33,0,0,1,.23,0,.61.61,0,0,1,.27.08l1.59.92a.52.52,0,0,1,.27-.34l.86-.5a1.62,1.62,0,0,1,1-.15,2.52,2.52,0,0,1,1.06.32l1.43.83a.23.23,0,0,1,.14.15c0,.06,0,.1-.06.14a.44.44,0,0,1-.24,0,.5.5,0,0,1-.27-.08l-1.43-.82a1.21,1.21,0,0,0-.53-.16.82.82,0,0,0-.47.07l-.87.5a.23.23,0,0,0-.13.27.51.51,0,0,0,.28.31l1.43.83a.23.23,0,0,1,.14.15c0,.06,0,.1-.06.14a.55.55,0,0,1-.24,0A.77.77,0,0,1,179,381l-4-2.32C174.91,378.58,174.86,378.53,174.85,378.48Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.67,418.86c7.59,4.38,7.59,11.48,0,15.86s-19.88,4.38-27.46,0-7.58-11.48,0-15.86S275.09,414.48,282.67,418.86Z",
    style: {
      fill: "#E68072"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,427.77c-6.6-6.74-10.48-23.57-4-28.91H285.6c6.44,5.34,2.56,22.16-4,28.9a1.62,1.62,0,0,1-.18.19l-.22.22c-.19.18-.39.36-.6.53l-.16.13c-.16.12-.32.25-.5.37a8.76,8.76,0,0,1-.85.55c-5.43,3.13-14.24,3.13-19.68,0h0c-.29-.16-.57-.35-.86-.55l-.46-.35-.2-.16a6.91,6.91,0,0,1-.57-.51l-.26-.25C257,427.87,256.91,427.82,256.86,427.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,396.7c7.48,4.32,7.48,11.32,0,15.64s-19.6,4.32-27.08,0-7.48-11.32,0-15.64S275.27,392.39,282.75,396.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,399.77c4.55,2.62,4.55,6.88,0,9.51s-11.93,2.63-16.48,0-4.55-6.89,0-9.51S272.9,397.14,277.45,399.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,404.28c4.55-2.63,11.93-2.63,16.48,0a7.7,7.7,0,0,1,2.73,2.5,7.7,7.7,0,0,1-2.73,2.5c-4.55,2.63-11.93,2.63-16.48,0a7.57,7.57,0,0,1-2.72-2.5A7.57,7.57,0,0,1,261,404.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.45,406.78a37.84,37.84,0,0,0,6-7.92c2.75-4.87,5.1-11.06,3.68-11.86s-9.06,5.36-9.06,5.36a35.38,35.38,0,0,0,.61-8.3c-.24-4.34-1.3-8.28-2.54-9.07s-4,4.67-5.21,8.64-1.67,6.42-1.67,6.42-1.05-4.56-2.37-8.32c-1.44-4.12-2.75-5.05-3.77-4.64s-1.69,2.32-2,7.8a54.49,54.49,0,0,0,.24,7.85s-2-2.25-4.31-4.43c-2.49-2.39-4.25-2.38-5-1.93s-.21,3.85,3.64,10.82a39.22,39.22,0,0,0,7.28,9.58S267.33,410.22,276.45,406.78Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.45,406.78a37.84,37.84,0,0,0,6-7.92c2.75-4.87,5.1-11.06,3.68-11.86s-9.06,5.36-9.06,5.36a35.38,35.38,0,0,0,.61-8.3c-.24-4.34-1.3-8.28-2.54-9.07s-4,4.67-5.21,8.64-1.67,6.42-1.67,6.42-1.05-4.56-2.37-8.32c-1.44-4.12-2.75-5.05-3.77-4.64s-1.69,2.32-2,7.8a54.49,54.49,0,0,0,.24,7.85s-2-2.25-4.31-4.43c-2.49-2.39-4.25-2.38-5-1.93s-.21,3.85,3.64,10.82a39.22,39.22,0,0,0,7.28,9.58S267.33,410.22,276.45,406.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M269.89,383.63c-1.19,4-1.67,6.42-1.67,6.42h0l.72,3.42s.75-7.47,1.8-12.27C270.41,382,270.12,382.85,269.89,383.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64,389.6a49.93,49.93,0,0,1-1.05-9.5,37.75,37.75,0,0,0-.49,4.79,54.49,54.49,0,0,0,.24,7.85l5.26,5.51A47.31,47.31,0,0,1,261.64,389.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.71,395.6l3.32-3.24h0a35.38,35.38,0,0,0,.61-8.3,30.18,30.18,0,0,0-.67-4.91,23,23,0,0,1-.39,8A73.24,73.24,0,0,1,273.71,395.6Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-589"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.64,32.41c-5.44-3.09-12.93-2.62-21.2,2.16-16.64,9.6-30.13,33-30.13,52.18,0,9.6,3.37,16.34,8.82,19.49l7.35,4.23c5.45,3.14,13,2.68,21.28-2.11,16.64-9.61,30.13-33,30.13-52.19,0-9.58-3.35-16.31-8.78-19.47C240.84,35.38,238,33.72,235.64,32.41Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,32.41c-5.44-3.09-12.93-2.62-21.2,2.16-16.64,9.6-30.13,33-30.13,52.18,0,9.6,3.37,16.34,8.82,19.49l7.35,4.23c5.45,3.14,13,2.68,21.28-2.11,16.64-9.61,30.13-33,30.13-52.19,0-9.58-3.35-16.31-8.78-19.47C240.84,35.38,238,33.72,235.64,32.41Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,114.45a16.45,16.45,0,0,1-5.5,5.46,15.27,15.27,0,0,1-8.27,2.08.8.8,0,0,1-.39-.09c-.44-.27-5.24-3-5.34-3.08a.75.75,0,0,1,0-1.3,13.32,13.32,0,0,0,6.88-10.36l5.34,3.08Z",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,114.45a16.45,16.45,0,0,1-5.5,5.46,15.27,15.27,0,0,1-8.27,2.08.8.8,0,0,1-.39-.09c-.44-.27-5.24-3-5.34-3.08a.75.75,0,0,1,0-1.3,13.32,13.32,0,0,0,6.88-10.36l5.34,3.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.76,
    cy: 73.57,
    rx: 42.61,
    ry: 24.6,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 47.17, 228.83)",
    style: {
      fill: "#E68072"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,106.94a13.32,13.32,0,0,1-6.8,13.65.75.75,0,0,0,.36,1.4,15.39,15.39,0,0,0,8.28-2.08c5.86-3.71,6.59-8.1,6.59-8.1Z",
    style: {
      fill: "#E68072"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.72,64.38c.05.92.07,1.74.07,2.46s0,1.54-.07,2.44A13.39,13.39,0,0,1,216.14,75,9.87,9.87,0,0,1,212.41,79c-1.52.89-2.76,1-3.71.36s-1.48-2-1.59-3.9c-.05-.85-.07-1.64-.07-2.36s0-1.57.07-2.54a13.25,13.25,0,0,1,1.5-5.74,9.86,9.86,0,0,1,3.8-4q2.43-1.4,3.81-.41C217.13,61.05,217.64,62.38,217.72,64.38ZM227,53.71a6.15,6.15,0,0,1,.47-1,2,2,0,0,1,.71-.65l3.4-2c.25-.14.44-.16.58-.06a.74.74,0,0,1,.21.61,1.57,1.57,0,0,1,0,.27,2.42,2.42,0,0,1-.1.36L216.09,93.43a6,6,0,0,1-.47,1,2.06,2.06,0,0,1-.71.66l-3.41,2q-.36.21-.57.06a.72.72,0,0,1-.21-.61,1.57,1.57,0,0,1,0-.27,2,2,0,0,1,.1-.36ZM211.35,73.23a2.89,2.89,0,0,0,.28,1.25c.15.29.42.32.78.11a1.76,1.76,0,0,0,.79-1,5.64,5.64,0,0,0,.28-1.57c.08-1.93.08-3.74,0-5.44a2.92,2.92,0,0,0-.28-1.25c-.15-.28-.42-.32-.79-.1a1.76,1.76,0,0,0-.78,1,5.64,5.64,0,0,0-.28,1.57C211.26,69.59,211.26,71.4,211.35,73.23Zm25.07-1.76q.06,1.38.06,2.46t-.06,2.43a13.3,13.3,0,0,1-1.59,5.74A9.85,9.85,0,0,1,231.11,86q-2.3,1.32-3.72.36c-.95-.65-1.48-2-1.59-3.91,0-.85-.07-1.63-.07-2.35s0-1.57.07-2.54a13.22,13.22,0,0,1,1.51-5.74,9.82,9.82,0,0,1,3.8-4q2.41-1.4,3.8-.4C235.83,68.14,236.33,69.47,236.42,71.47ZM230,80.32a2.92,2.92,0,0,0,.28,1.25c.16.28.42.31.79.1a1.77,1.77,0,0,0,.79-1,5.71,5.71,0,0,0,.27-1.57c.09-1.93.09-3.75,0-5.45a3,3,0,0,0-.27-1.25c-.16-.28-.42-.31-.79-.1a1.77,1.77,0,0,0-.79,1,5.77,5.77,0,0,0-.28,1.57C230,76.67,230,78.49,230,80.32Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountantAmico);
export default __webpack_public_path__ + "static/media/Accountant-amico.1d00a4a3fea7e5dd8edbe9fad54ece0b.svg";
export { ForwardRef as ReactComponent };